import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addDays from "date-fns/add_days";
import subMonths from 'date-fns/sub_months';
import addYears from 'date-fns/add_years';
import {getDate} from 'date-fns';
import lastDayOfMonth from 'date-fns/last_day_of_month'
import { getTeamByCompany,getCompany, getHerePoint } from './core/cacheService'
import { getCompanyTimezone, toCompanyDate } from './utils/companyTimezone'
export default {
    namespaced: true,
    state: {
        outbox: [],
        list_month: [],
        teamAndcohort: [],
        recognitionValue: [],
        recognition: [],
        alignment:[],
        givenMember:[],
        impact_rating:{},
        recognitionAll: [],
        alignmentAll:[],
        cohortUser:[],
        organization:[],
        statusTime:false,
        statusTeam:false,
        dataAll:[],
        time:'Past 6 months',
        tag:'All',
        loadings: true,
        loadingsImpactRating:true,
        receivedMember:[],
        pickerOptions: {},
        statusschedule:false,
        startDate:'',
        endDate:'',
        dataAllnotpast6month:[],
        statusnotpast6month:false,

    },
    mutations: {

        setList_month(state : any, result : any) {
            state.list_month = result
        },
        setpickerOptions (state : any, result : any) {
            state.pickerOptions = result
        },
        setteamAndcohort(state : any, result : any) {
            state.teamAndcohort = result
        },
        setRecognitionValue(state : any, result : any) {
            state.recognitionValue = result
        },
        setRecognition(state : any, result : any) {
            state.recognition = result
        },
        setAlignment(state : any, result : any) {
            state.alignment = result
        },
        setGivenMember(state : any, result : any) {
            state.givenMember = result
        },
        setReceivedMember(state : any, result : any) {
            state.receivedMember = result
        },
        setImpactRating(state : any, result : any) {
            state.impact_rating = result
        },
        setRecognitionAll(state : any, result : any) {
            state.recognitionAll = result
        },
        setAlignmentAll(state : any, result : any) {
            state.alignmentAll = result
        },
        setcohortUser(state : any, result : any) {
            state.cohortUser = result
        },
        setOrganization(state:any, result:any) {
            state.organization = result
        },
        setloadingsImpactRating(state:any, result:any){
            state.loadingsImpactRating = result
        },
        setloadings(state:any, result:any){
            state.loadings = result
        }

    },
    actions: {
        getList_month(
            {commit, dispatch, state} : any,
            user : any
        ) {

            let arr_list_month: Array<any> = [];
            let list_month: Array<any> = [];
            arr_list_month = [
                // {
                //     'name': 'All-time',
                //     'id': 'All-time'
                // },
                {
                    'name': 'Past 30 days',
                    'id': 'Past 30 days'
                },
                {
                    'name': 'Past 3 months',
                    'id': 'Past 3 months'
                },
                {
                    'name': 'Past 6 months',
                    'id': 'Past 6 months'
                }, 
                {
                    'name': 'Custom Date Range',
                    'id': 'Custom Date Range'
                },
            ]
            for(let i=0;i<6;i++){
                list_month.push({text: format(subMonths(new Date(), i), 'MMMM'),onClick(picker) {
                    const end = format(lastDayOfMonth(subMonths(new Date(), i)), 'YYYY-MM-DD')
                    const start = format(subMonths(new Date(), i), 'YYYY-MM-01');
                   
                    picker.$emit('pick', [start, end]);
                }})
            }
             commit('setpickerOptions', {shortcuts:list_month})
            commit('setList_month', arr_list_month)
        },
        async getteamAndcohort(
            {commit, dispatch, state, rootState} : any,
            user : any
        ) {
            let teamAndcohort: Array<any> = [];
            let cohortUser={}
            const allteam =await getTeamByCompany(user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
            if(rootState.authen.user.user_type == 'leadership'){
                let result:Array<any>=[]
                await firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).get()
                .then((querySnapshot)=> {
                        querySnapshot.forEach((doc)=> {
                          const team_id=doc.data().team_id
                          result[team_id]=doc.data().parent
        
                        });
                if(result[rootState.authen.user.team]){
                    for(const key in result[rootState.authen.user.team]){
                        teamAndcohort.push({key: key, name: allteam[key].name})
                    }
                }else{
                    teamAndcohort.push({key: rootState.authen.user.team, name: allteam[rootState.authen.user.team].name})
                }
                    
                    
                commit('setteamAndcohort', teamAndcohort)
                });


            }else{
                teamAndcohort.push({key: 'All Teams and Cohorts', name: 'All Teams and Cohorts'})
           
            for (const i in allteam) {
                if (!allteam[i] || typeof allteam[i] !== 'object') continue; allteam[i].key = i
                allteam[i].value = allteam[i].name
                teamAndcohort.push(allteam[i])
            }

            firebase.database().ref(`cohorts/${
                user.company
            }`).once('value', (snapshot) => {
                snapshot.forEach((doc) => {
                    const cohort = doc.val()
                    cohort.key = doc.key
                    cohort.value = doc.val().name
                    if(!cohortUser[cohort.key]){
                        cohortUser[cohort.key]=cohort.users
                    }
                    
                    teamAndcohort.push(cohort)
                });
                teamAndcohort = _.sortBy(teamAndcohort, [
                    function (o) {
                        return o.name;
                    },
                ]);
                commit('setteamAndcohort', teamAndcohort)
                commit('setcohortUser', cohortUser)
            });

            }
            
        },
        async getRecognition(
            {commit, dispatch, state} : any,
            user : any
        ) {
            let recognitionValue: any = []
            let companyData =await getCompany(user.company)
            if (companyData.hashtag) {
                for (var value in companyData.hashtag) {
                    recognitionValue.push({value: value, label: companyData.hashtag[value].name});

                }
                commit('setRecognitionValue', recognitionValue)
            }
        },
        async getHerepoint(
            {commit, dispatch, state,rootState} : any,
            user : any
        ) {
            commit('setloadings', true)
            
            state.dataAll=[]
            let data: any = []
            const timezone = await getCompanyTimezone(user.company)
            const companyNow = toCompanyDate(new Date(), timezone)
            let date = format(addDays(companyNow, -180), 'YYYY-MM-DD')
            let recognition = {}
            let alignment={}
            let givenMember={}
            let receivedMember={}
            const alluser=rootState.main.allUser
            const team=rootState.main.allTeam
            //console.log('getHerepoint')
            //const herepoint=await getHerePoint(user.company,['sendcoin','sendgem'],date)
            const herepoint=(await firebase.firestore().collection('here_point').where('company','==',user.company).where('date','>=',date).where('statusrow','in',['sendcoin']).get()).docs.map(doc=>doc.data())


            //console.log('herepoint',herepoint)
            for(const i in herepoint){
                const u = herepoint[i]
                    u.id = i
                    u.dateFormatted = format(u.date, 'MMM DD, YYYY')
                    state.dataAll.push(u)
                    if (u.statusrow == 'sendcoin') {
                        if(!givenMember[u.sender_email]){
                            givenMember[u.sender_email]=[]
                        }
                        if (u.type=='gem'){
                            u.hashtags=[]
                        }
                        if(u.core_value_ai){
                            if(!u.hashtags){
                                u.hashtags=[]
                            }
                            let count=0
                            for(const i in u.core_value_ai){
                                if(u.core_value_ai[i].rating>4){
                                    u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
                                    count++
                                }else{
                                    if(u.hashtag_prev){
                                        u.hashtags[count]={name:u.hashtag_prev[count],rating:u.core_value_ai[i].rating}
                                    }else{
                                        u.hashtags[count]={name:'',rating:u.core_value_ai[i].rating}
                                    }
                                }
                                
                            }
                        }
                        const _emailKey=u.send_to_email.replace(/\./g, '||')
                        u.profilepic=alluser[_emailKey]&&alluser[_emailKey].profilepic?alluser[_emailKey].profilepic:'',
                        u.shortname=alluser[_emailKey]?alluser[_emailKey].firstname.charAt(0) + alluser[_emailKey].lastname.charAt(0):'',
                        givenMember[u.sender_email].push(u)

                        if(!receivedMember[u.send_to_email]){
                            receivedMember[u.send_to_email]=[]
                        }
                        receivedMember[u.send_to_email].push(u)
                     
                        let emailKey=u.sender_email.replace(/\./g, '||')

                        
                        if(alluser[emailKey]){
                            if (! recognition[u.sender_email]) {
                                recognition[u.sender_email] = {
                                    key:u.id,
                                    email: u.sender_email,
                                    // email_to:u.send_to_email,
                                    profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                    firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                    lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                    shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                    teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                    team_id:alluser[emailKey].team,
                                    impactRating:alluser[emailKey].impact_rating,
                                    tag:u.hashtag,
                                    date:u.date,
                                    given: 0,
                                    received: 0,
                                    ratio: '',
                                }
                            }
                        recognition[u.sender_email].given ++

                        }
                        emailKey=u.send_to_email.replace(/\./g, '||')
                        
                        if(alluser[emailKey]){
                            if (! recognition[u.send_to_email]) {
                            const emailKey=u.send_to_email.replace(/\./g, '||')
                            recognition[u.send_to_email] = {
                                key:u.id,
                                email: u.send_to_email,
                                // email_to:u.send_to_email,
                                profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                team_id:alluser[emailKey].team,
                                impactRating:alluser[emailKey].impact_rating,
                                tag:u.hashtag,
                                date:u.date,
                                given: 0,
                                received: 0,
                                ratio: '',
                                sortRatio:0,
                                order_Ratio:0,
                                order_Received:0,
                                order_Given:0
                            }
                            }
                            recognition[u.send_to_email].received ++
                        }
                        if(u.core_value_ai){
                            emailKey=u.sender_email.replace(/\./g, '||')
                            if(alluser[emailKey]){
                                if(!alignment[u.sender_email]){
                                    alignment[u.sender_email]={
                                        email: u.sender_email,
                                        profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                        firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                        lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                        shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                        teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                        team_id:alluser[emailKey].team,
                                        impactRating:alluser[emailKey].impact_rating,
                                        tag:u.hashtag,
                                        effortGiven:0,
                                        totalGiven:0,
                                        effortReceived:0,
                                        totalReceived:0,
                                        alignmentGiven:0,
                                        alignmentReceived:0,
                                        alignmentRatio:0}
                                }
                                

                            }
                            emailKey=u.send_to_email.replace(/\./g, '||')
                            if(alluser[emailKey]){
                                if(!alignment[u.send_to_email]){
                                    //const emailKey=u.send_to_email.replace(/\./g, '||')
                                    alignment[u.send_to_email]={
                                        email: u.send_to_email,
                                        profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                        firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                        lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                        shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                        teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                        team_id:alluser[emailKey].team,
                                        effortGiven:0,
                                        totalGiven:0,
                                        effortReceived:0,
                                        totalReceived:0,
                                        impactRating:alluser[emailKey].impact_rating,
                                        alignmentGiven:0,
                                        alignmentReceived:0,
                                        alignmentRatio:0,
                                        order_alignmentRatio:0,
                                        order_alignmentGiven:0,
                                        order_alignmentReceived:0}
                                }
                                
                            }
                            let rating = 0;
                            let _rating = 0;
                            if(u.statusrow == 'sendcoin'){
                                for(const i in u.core_value_ai){
                                    if(u.core_value_ai[i].rating){
                                       
                                        emailKey=u.sender_email.replace(/\./g, '||')
                                        if(alluser[emailKey]){
                                            if(_rating < parseFloat(u.core_value_ai[i].rating)){
                                                _rating = parseFloat(u.core_value_ai[i].rating);
                                            }
                                            
                                        }
    
                                        emailKey=u.send_to_email.replace(/\./g, '||')
                                        
                                        if(alluser[emailKey]){
                                            if(rating < parseFloat(u.core_value_ai[i].rating)){
                                                rating = parseFloat(u.core_value_ai[i].rating);
                                            }
                                            
                                        }
                                    }
                                  
                                 
                                }
                                emailKey=u.sender_email.replace(/\./g, '||')
                                if(alluser[emailKey]){
                                    
                                    alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+_rating
                                    alignment[u.sender_email].totalGiven++
                                }
                                
                                emailKey=u.send_to_email.replace(/\./g, '||')
                                
                                if(alluser[emailKey]){
                                    
                                alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+rating
                                alignment[u.send_to_email].totalReceived++
                                }
                            }

                        }
                    }
            }

            for (const i in recognition) {
                    
                if (recognition[i].received > 0) {
                    recognition[i].sortRatio=(recognition[i].given / recognition[i].received)
                    recognition[i].ratio = (recognition[i].given / recognition[i].received).toFixed(1)
                } else {
                    recognition[i].sortRatio=recognition[i].given
                    recognition[i].ratio = recognition[i].given.toFixed() + '*'
                }
                
            }
            for(const i in alignment){
               
                if(alignment[i].totalGiven>0){
                    alignment[i].alignmentGiven=isNaN(alignment[i].effortGiven/alignment[i].totalGiven)?0: (alignment[i].effortGiven/alignment[i].totalGiven).toFixed(1)
                }
                if(alignment[i].totalReceived>0){
                    alignment[i].alignmentReceived= isNaN(alignment[i].effortReceived/alignment[i].totalReceived)?0:(alignment[i].effortReceived/alignment[i].totalReceived).toFixed(1)
                }
                alignment[i].alignmentRatio= isNaN((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived))?0:((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived)).toFixed(1)
            }

        const given = _.orderBy(recognition, ['given'], ['desc'])
        const received = _.orderBy(recognition, ['received'], ['desc'])
        const sortRatio = _.orderBy(recognition, ['sortRatio'], ['desc'])
        let count=0
        let given_order=0
        for(const i in given){
          if(given_order!=recognition[given[i].email].given){
            given_order=recognition[given[i].email].given
            count++
            state.last_rank_given=count
          }
            recognition[given[i].email].order_Given=count
          if(count%10==1){
            recognition[given[i].email].orderGiven=count+'st'
          }else if(count%10==2){
            recognition[given[i].email].orderGiven=count+'nd'
          }else if(count%10==3){
            recognition[given[i].email].orderGiven=count+'rd'
          }else{
            recognition[given[i].email].orderGiven=count+'th'
          }
        }
        let count_received=0
        let received_order=0
        for(const i in received){
          if(received_order!=recognition[received[i].email].received){
            received_order=recognition[received[i].email].received
            count_received++
            state.last_rank_received=count_received
          }
          recognition[received[i].email].order_Received=count_received
          if(count_received%10==1){
            recognition[received[i].email].orderReceived=count_received+'st'
          }else if(count_received%10==2){
            recognition[received[i].email].orderReceived=count_received+'nd'
          }else if(count_received%10==3){
            recognition[ received[i].email].orderReceived=count_received+'rd'
          }else{
            recognition[ received[i].email].orderReceived=count_received+'th'
          }

          
        }
        let count_ratio=0
        let ratio_order=0
        for(const i in sortRatio){
          if(ratio_order!=recognition[sortRatio[i].email].sortRatio){
            ratio_order=recognition[sortRatio[i].email].sortRatio
            count_ratio++
            state.last_rank_ratio=count_ratio
          }
          
          recognition[sortRatio[i].email].order_Ratio=count_ratio
          if(count_ratio%10==1){
            recognition[sortRatio[i].email].orderRatio=count_ratio+'st'
          }else if(count_ratio%10==2){
            recognition[sortRatio[i].email].orderRatio=count_ratio+'nd'
          }else if(count_ratio%10==3){
            recognition[sortRatio[i].email].orderRatio=count_ratio+'rd'
          }else{
            recognition[sortRatio[i].email].orderRatio=count_ratio+'th'
          }
        }
        const alignmentGiven = _.orderBy(alignment, ['alignmentGiven'], ['desc'])
        
        const alignmentReceived = _.orderBy(alignment, ['alignmentReceived'], ['desc'])
        const alignmentRatio = _.orderBy(alignment, ['alignmentRatio'], ['desc'])
        let count_alignmentGiven=0
        let alignmentGiven_order=0
        for(const i in alignmentGiven){
            if(alignmentGiven_order!=alignment[alignmentGiven[i].email].alignmentGiven){
              alignmentGiven_order=alignment[alignmentGiven[i].email].alignmentGiven
              count_alignmentGiven++
            }
            
                alignment[alignmentGiven[i].email].order_alignmentGiven=count_alignmentGiven
        }

        let count_alignmentReceived=0
        let alignmentReceived_order=0
        for(const i in alignmentReceived){
            if(alignmentReceived_order!=alignment[alignmentReceived[i].email].alignmentReceived){
                alignmentReceived_order=alignment[alignmentReceived[i].email].alignmentReceived
              count_alignmentReceived++
            }
                alignment[alignmentReceived[i].email].order_alignmentReceived=count_alignmentReceived
        }
        let count_alignmentRatio=0
        let alignmentRatio_order=0
        for(const i in alignmentRatio){
            if(alignmentRatio_order!=alignment[alignmentRatio[i].email].alignmentRatio){
                alignmentRatio_order=alignment[alignmentRatio[i].email].alignmentRatio
                count_alignmentRatio++
            }
                alignment[alignmentRatio[i].email].order_alignmentRatio=count_alignmentRatio
        }
            


            commit('setRecognition', recognition)
            commit('setAlignment', alignment)
            commit('setGivenMember', givenMember)
            commit('setReceivedMember', receivedMember)
            commit('setRecognitionAll', recognition)
            commit('setAlignmentAll', alignment)
            commit('setImpactRating',alluser)
            if(rootState.authen.user.user_type !== 'leadership'){
                commit('setloadings', false)
            }else {
                await dispatch('changeTeam',rootState.authen.user.team)
                commit('setloadings', false)
            }

            // await firebase.firestore().collection('here_point').where('company', '==', user.company).where('statusrow','in',['sendcoin','sendgem']).where('date', '>=', date).get().then(async (querySnapshot) => {
            //     querySnapshot.forEach((doc) => {
            //         const u = doc.data()
            //         u.id = doc.id
            //         u.dateFormatted = format(u.date, 'MMM DD, YYYY')
            //         state.dataAll.push(u)
            //         if (u.statusrow == 'sendcoin' || u.statusrow == 'sendgem') {
            //             if(!givenMember[u.sender_email]){
            //                 givenMember[u.sender_email]=[]
            //             }
            //             if (u.type=='gem'){
            //                 u.hashtags=[]
            //             }
            //             if(u.core_value_ai){
            //                 let count=0
            //                 for(const i in u.core_value_ai){
            //                     if(u.core_value_ai[i].rating>4){
            //                         u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
            //                         count++
            //                     }else{
            //                         if(u.hashtag_prev){
            //                             u.hashtags[count]={name:u.hashtag_prev[count],rating:u.core_value_ai[i].rating}
            //                         }else{
            //                             u.hashtags[count]={name:'',rating:u.core_value_ai[i].rating}
            //                         }
            //                     }
                                
            //                 }
            //             }
            //             const _emailKey=u.send_to_email.replace(/\./g, '||')
            //             u.profilepic=alluser[_emailKey]&&alluser[_emailKey].profilepic?alluser[_emailKey].profilepic:'',
            //             u.shortname=alluser[_emailKey]?alluser[_emailKey].firstname.charAt(0) + alluser[_emailKey].lastname.charAt(0):'',
            //             givenMember[u.sender_email].push(u)

            //             if(!receivedMember[u.send_to_email]){
            //                 receivedMember[u.send_to_email]=[]
            //             }
            //             receivedMember[u.send_to_email].push(u)
                     
            //             let emailKey=u.sender_email.replace(/\./g, '||')

                        
            //             if(alluser[emailKey]){
            //                 if (! recognition[u.sender_email]) {
            //                     recognition[u.sender_email] = {
            //                         key:u.id,
            //                         email: u.sender_email,
            //                         // email_to:u.send_to_email,
            //                         profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
            //                         firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
            //                         lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
            //                         shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
            //                         teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
            //                         team_id:alluser[emailKey].team,
            //                         impactRating:alluser[emailKey].impact_rating,
            //                         tag:u.hashtag,
            //                         date:u.date,
            //                         given: 0,
            //                         received: 0,
            //                         ratio: '',
            //                     }
            //                 }
            //             recognition[u.sender_email].given ++

            //             }
            //             emailKey=u.send_to_email.replace(/\./g, '||')
                        
            //             if(alluser[emailKey]){
            //                 if (! recognition[u.send_to_email]) {
            //                 const emailKey=u.send_to_email.replace(/\./g, '||')
            //                 recognition[u.send_to_email] = {
            //                     key:u.id,
            //                     email: u.send_to_email,
            //                     // email_to:u.send_to_email,
            //                     profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
            //                     firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
            //                     lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
            //                     shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
            //                     teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
            //                     team_id:alluser[emailKey].team,
            //                     impactRating:alluser[emailKey].impact_rating,
            //                     tag:u.hashtag,
            //                     date:u.date,
            //                     given: 0,
            //                     received: 0,
            //                     ratio: '',
            //                     sortRatio:0,
            //                     order_Ratio:0,
            //                     order_Received:0,
            //                     order_Given:0
            //                 }
            //                 }
            //                 recognition[u.send_to_email].received ++
            //             }
            //             if(u.core_value_ai){
            //                 emailKey=u.sender_email.replace(/\./g, '||')
            //                 if(alluser[emailKey]){
            //                     if(!alignment[u.sender_email]){
            //                         alignment[u.sender_email]={
            //                             email: u.sender_email,
            //                             profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
            //                             firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
            //                             lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
            //                             shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
            //                             teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
            //                             team_id:alluser[emailKey].team,
            //                             impactRating:alluser[emailKey].impact_rating,
            //                             tag:u.hashtag,
            //                             effortGiven:0,
            //                             totalGiven:0,
            //                             effortReceived:0,
            //                             totalReceived:0,
            //                             alignmentGiven:0,
            //                             alignmentReceived:0,
            //                             alignmentRatio:0}
            //                     }
                                

            //                 }
            //                 emailKey=u.send_to_email.replace(/\./g, '||')
            //                 if(alluser[emailKey]){
            //                     if(!alignment[u.send_to_email]){
            //                         //const emailKey=u.send_to_email.replace(/\./g, '||')
            //                         alignment[u.send_to_email]={
            //                             email: u.send_to_email,
            //                             profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
            //                             firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
            //                             lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
            //                             shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
            //                             teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
            //                             team_id:alluser[emailKey].team,
            //                             effortGiven:0,
            //                             totalGiven:0,
            //                             effortReceived:0,
            //                             totalReceived:0,
            //                             impactRating:alluser[emailKey].impact_rating,
            //                             alignmentGiven:0,
            //                             alignmentReceived:0,
            //                             alignmentRatio:0,
            //                             order_alignmentRatio:0,
            //                             order_alignmentGiven:0,
            //                             order_alignmentReceived:0}
            //                     }
                                
            //                 }
            //                 let rating = 0;
            //                 let _rating = 0;
            //                 if(u.statusrow == 'sendcoin'){
            //                     for(const i in u.core_value_ai){
            //                         if(u.core_value_ai[i].rating){
                                       
            //                             emailKey=u.sender_email.replace(/\./g, '||')
            //                             if(alluser[emailKey]){
            //                                 if(_rating < parseFloat(u.core_value_ai[i].rating)){
            //                                     _rating = parseFloat(u.core_value_ai[i].rating);
            //                                 }
                                            
            //                             }
    
            //                             emailKey=u.send_to_email.replace(/\./g, '||')
                                        
            //                             if(alluser[emailKey]){
            //                                 if(rating < parseFloat(u.core_value_ai[i].rating)){
            //                                     rating = parseFloat(u.core_value_ai[i].rating);
            //                                 }
                                            
            //                             }
            //                         }
                                  
                                 
            //                     }
            //                     emailKey=u.sender_email.replace(/\./g, '||')
            //                     if(alluser[emailKey]){
                                    
            //                         alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+_rating
            //                         alignment[u.sender_email].totalGiven++
            //                     }
                                
            //                     emailKey=u.send_to_email.replace(/\./g, '||')
                                
            //                     if(alluser[emailKey]){
                                    
            //                     alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+rating
            //                     alignment[u.send_to_email].totalReceived++
            //                     }
            //                 }

            //             }
            //         }
            //     });
            //     for (const i in recognition) {
                    
            //         if (recognition[i].received > 0) {
            //             recognition[i].sortRatio=(recognition[i].given / recognition[i].received)
            //             recognition[i].ratio = (recognition[i].given / recognition[i].received).toFixed(1)
            //         } else {
            //             recognition[i].sortRatio=recognition[i].given
            //             recognition[i].ratio = recognition[i].given.toFixed() + '*'
            //         }
                    
            //     }
            //     for(const i in alignment){
                   
            //         if(alignment[i].totalGiven>0){
            //             alignment[i].alignmentGiven=isNaN(alignment[i].effortGiven/alignment[i].totalGiven)?0: (alignment[i].effortGiven/alignment[i].totalGiven).toFixed(1)
            //         }
            //         if(alignment[i].totalReceived>0){
            //             alignment[i].alignmentReceived= isNaN(alignment[i].effortReceived/alignment[i].totalReceived)?0:(alignment[i].effortReceived/alignment[i].totalReceived).toFixed(1)
            //         }
            //         alignment[i].alignmentRatio= isNaN((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived))?0:((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived)).toFixed(1)
            //     }

            // const given = _.orderBy(recognition, ['given'], ['desc'])
            // const received = _.orderBy(recognition, ['received'], ['desc'])
            // const sortRatio = _.orderBy(recognition, ['sortRatio'], ['desc'])
            // let count=0
            // let given_order=0
            // for(const i in given){
            //   if(given_order!=recognition[given[i].email].given){
            //     given_order=recognition[given[i].email].given
            //     count++
            //     state.last_rank_given=count
            //   }
            //     recognition[given[i].email].order_Given=count
            //   if(count%10==1){
            //     recognition[given[i].email].orderGiven=count+'st'
            //   }else if(count%10==2){
            //     recognition[given[i].email].orderGiven=count+'nd'
            //   }else if(count%10==3){
            //     recognition[given[i].email].orderGiven=count+'rd'
            //   }else{
            //     recognition[given[i].email].orderGiven=count+'th'
            //   }
            // }
            // let count_received=0
            // let received_order=0
            // for(const i in received){
            //   if(received_order!=recognition[received[i].email].received){
            //     received_order=recognition[received[i].email].received
            //     count_received++
            //     state.last_rank_received=count_received
            //   }
            //   recognition[received[i].email].order_Received=count_received
            //   if(count_received%10==1){
            //     recognition[received[i].email].orderReceived=count_received+'st'
            //   }else if(count_received%10==2){
            //     recognition[received[i].email].orderReceived=count_received+'nd'
            //   }else if(count_received%10==3){
            //     recognition[ received[i].email].orderReceived=count_received+'rd'
            //   }else{
            //     recognition[ received[i].email].orderReceived=count_received+'th'
            //   }

              
            // }
            // let count_ratio=0
            // let ratio_order=0
            // for(const i in sortRatio){
            //   if(ratio_order!=recognition[sortRatio[i].email].sortRatio){
            //     ratio_order=recognition[sortRatio[i].email].sortRatio
            //     count_ratio++
            //     state.last_rank_ratio=count_ratio
            //   }
              
            //   recognition[sortRatio[i].email].order_Ratio=count_ratio
            //   if(count_ratio%10==1){
            //     recognition[sortRatio[i].email].orderRatio=count_ratio+'st'
            //   }else if(count_ratio%10==2){
            //     recognition[sortRatio[i].email].orderRatio=count_ratio+'nd'
            //   }else if(count_ratio%10==3){
            //     recognition[sortRatio[i].email].orderRatio=count_ratio+'rd'
            //   }else{
            //     recognition[sortRatio[i].email].orderRatio=count_ratio+'th'
            //   }
            // }
            // const alignmentGiven = _.orderBy(alignment, ['alignmentGiven'], ['desc'])
            
            // const alignmentReceived = _.orderBy(alignment, ['alignmentReceived'], ['desc'])
            // const alignmentRatio = _.orderBy(alignment, ['alignmentRatio'], ['desc'])
            // let count_alignmentGiven=0
            // let alignmentGiven_order=0
            // for(const i in alignmentGiven){
            //     if(alignmentGiven_order!=alignment[alignmentGiven[i].email].alignmentGiven){
            //       alignmentGiven_order=alignment[alignmentGiven[i].email].alignmentGiven
            //       count_alignmentGiven++
            //     }
                
            //         alignment[alignmentGiven[i].email].order_alignmentGiven=count_alignmentGiven
            // }

            // let count_alignmentReceived=0
            // let alignmentReceived_order=0
            // for(const i in alignmentReceived){
            //     if(alignmentReceived_order!=alignment[alignmentReceived[i].email].alignmentReceived){
            //         alignmentReceived_order=alignment[alignmentReceived[i].email].alignmentReceived
            //       count_alignmentReceived++
            //     }
            //         alignment[alignmentReceived[i].email].order_alignmentReceived=count_alignmentReceived
            // }
            // let count_alignmentRatio=0
            // let alignmentRatio_order=0
            // for(const i in alignmentRatio){
            //     if(alignmentRatio_order!=alignment[alignmentRatio[i].email].alignmentRatio){
            //         alignmentRatio_order=alignment[alignmentRatio[i].email].alignmentRatio
            //         count_alignmentRatio++
            //     }
            //         alignment[alignmentRatio[i].email].order_alignmentRatio=count_alignmentRatio
            // }
                


            //     commit('setRecognition', recognition)
            //     commit('setAlignment', alignment)
            //     commit('setGivenMember', givenMember)
            //     commit('setReceivedMember', receivedMember)
            //     commit('setRecognitionAll', recognition)
            //     commit('setAlignmentAll', alignment)
            //     commit('setImpactRating',alluser)
            //     if(rootState.authen.user.user_type !== 'leadership'){
            //         commit('setloadings', false)
            //     }else {
            //         await dispatch('changeTeam',rootState.authen.user.team)
            //         commit('setloadings', false)
            //     }
                
            // });
        },
        async calculateImpactRating({commit, dispatch, state,rootState} : any,
            user : any){
            commit('setloadingsImpactRating', true)
            const maxMedalAndTruly = 4;
            const maxStarperformer = 6;
            const companies = user.company
            const impact_rating = {}
            const timezone = await getCompanyTimezone(user.company)
            const companyNow = toCompanyDate(new Date(), timezone)
            let date=''
            if(state.time=='Past 30 days'){
                date = format(addDays(companyNow, -30), 'YYYY-MM-DD')
           }else if(state.time=='Past 3 months'){
                date = format(addDays(companyNow, -90), 'YYYY-MM-DD')
           }else{
                date = format(addDays(companyNow, -180), 'YYYY-MM-DD')
           }
            const talent_type = {
                    'Marginalized':0,
                    'Up-and-coming':4,
                    'Contributor':4,
                    'Supported':6,
                    'Rising Star':6,
                    'Crowd Favorite':6,
                    'Underutilized':8,
                    'High Contributor':8,
                    'Developing':8,
                    'Hidden Talent':8,
                    'Activated':10,
                    'Core Player':10,
                    'High Potential':10,
                    'High Performer':12,
                    'Solid Performer':12,
                    'Superstar':16,
            };
            const network_type = {
                'Low Network':0,
                'Medium Outer':4,
                'Medium Inner':4,
                'Medium Network':6,
                'High Outer':8,
                'High Inner':8,
                'High Network':12,
                'Super Outer':12,
                'Super Inner':12,
                'Super Network':16,
            };
            const engagement = {
                'Highly Engaged':4,
                'Moderatly Engaged':3,
                'Somewhat Engaged':2,
                'Under Engaged':1,
                'Inactive':0
            };
                    let medals = {};
                    let truly = {};
                    let starperformers = {};
                    await firebase.firestore().collection('report_weekly_performer_all').where('company','==',companies).where('date','>=',date).get().then( async query => {
                        query.forEach((doc) => {
                            const emailKey = doc.data().email.replace(/\./g, '||');
                            if(!starperformers[emailKey]){
                                starperformers[emailKey] = 0;
                            }
                            starperformers[emailKey] = (starperformers[emailKey])?starperformers[emailKey]+1:1;
                        });
                    });
                    await firebase.firestore().collection('peerfeedback').where('company','==',companies).where('date','>=',date).get().then( async query => {
                        query.forEach((doc) => {
                            if(doc.data().suggest.line1_en === 'Truly'){
                                const emailKey = doc.data().email_to.replace(/\./g, '||');
                                truly[emailKey] = (truly[emailKey])?truly[emailKey]+1:1;
                            }
                        });
                    });
                    const datasend = [];
                    const datareceive = [];
                    const users =rootState.main.allUser
                    const signature = ['brokerage','collective','cohesion','reachability','influence','connectivity','ripple','hub','strategist','community_leader','linker'];
                    const relMaster = (await firebase.database().ref('rel_maps').orderByChild("comp_id").equalTo(user.company).once('value')).val()
                    for(const user in users){
                        if (users.hasOwnProperty(user)) {// && (user === 'tareef_j@dhas||com' || user === 'wittawat_b@dhas||com')
                            let relation = 0;
                            const rel_maps=relMaster[user]
                            if(rel_maps){
                                for(const s in rel_maps){
                                    if(signature.includes(s)){
                                        if(Number(rel_maps[s]) >= 0.85){
                                            relation++;
                                        }
                                    }
                                }
                            }
                            const t1 = (talent_type[users[user].talent])?(talent_type[users[user].talent]*0.2/16)*100:0;//= 20
                            const t2 = (network_type[users[user].network_type])?(network_type[users[user].network_type]*0.1/16)*100:0;//=20
                            const t3 = (engagement[users[user].engagement_group])?(engagement[users[user].engagement_group]*0.2/4)*100:0;//30
                            const t4 = (relation>0)?10:0;
                            let t5 = 0;
                            const emailKey = user.replace(/\|\|/g, '.');
                            if(datasend[emailKey] && datasend[emailKey].total_rating && datasend[emailKey].total){
                                t5 = ((datasend[emailKey].total_rating/datasend[emailKey].total)*10)*0.1;
                            }
                            let t6 = 0;
                            if(datareceive[emailKey] && datareceive[emailKey].total_rating && datareceive[emailKey].total){
                                t6 = ((datareceive[emailKey].total_rating/datareceive[emailKey].total)*10)*0.1;
                            }

                            const medal = (medals[user])?medals[user]:0;
                            const truely = (truly[user])?truly[user]:0;
                            const starperformer = (starperformers[user])?starperformers[user]:0;
                            let tm = 0;
                            let sp = 0;
                            if((medal+truely)>maxMedalAndTruly){
                                tm = 10; //= 20
                            }else{
                                tm = ((medal+truely)/4)*10;
                            }
                            if(starperformer>maxStarperformer){
                                sp = ((maxStarperformer/maxStarperformer)*0.1)*100;
                            }else{
                                sp = ((starperformer/maxStarperformer)*0.1)*100;
                            }

                            const impactRating = (Number(t1)+Number(t2)+Number(t3)+Number(tm)+Number(sp)+Number(t4)+Number(t5)+Number(t6)).toFixed(2);
                            if(!impact_rating[users[user].email]){
                                impact_rating[users[user].email] =impactRating
                            }
                        }
                        
                    }
                    commit('setImpactRating', impact_rating)
                    commit('setloadingsImpactRating', false)
                    // console.log('setImpactRating',impact_rating)
                    // commit('setImpactRating', impact_rating)
                   
                
            
        },
        async changeTeam({commit, dispatch, state,rootState} : any,value : any){
            state.statusTeam=value
            let recognitionAll=[]
            let alignmentAll=[]
            recognitionAll=state.recognitionAll
            alignmentAll=state.alignmentAll
            const team=rootState.main.allTeam
            for(const i in team){
                team[i].key=i
            }
            if(value=='All Teams and Cohorts'){
                state.statusTeam=''
                commit('setRecognition', recognitionAll)
                commit('setAlignment', alignmentAll)
            }else{
                const _findteam=_.find(team, function(o) { return o.key == value; });
            if(_findteam){
                
                const recognition:any=[]
                const alignment:any=[]
                if(state.organization[value]){
              
                    for(const i in state.organization[value]){
                        const _recognition = _.filter(recognitionAll, function(o) { return o.team_id ==i; });
                        const _alignment = _.filter(alignmentAll, function(o) { return o.team_id == i; });
                        recognition.push(..._recognition)
                        alignment.push(..._alignment)
                  
                    }
                    
                    commit('setRecognition', recognition)
                    commit('setAlignment', alignment)

                }else{
                    const recognition = _.filter(recognitionAll, function(o) { return o.team_id == value; });
                    const alignment = _.filter(alignmentAll, function(o) { return o.team_id == value; });
                    commit('setRecognition', recognition)
                    commit('setAlignment', alignment)
                }
                
            }else{
                const recognition={}
                const alignment={}
                if(state.cohortUser[value]){
                                
                    for(const user in state.cohortUser[value]){
                        if(recognitionAll[ state.cohortUser[value][user]]){
                            recognition[ state.cohortUser[value][user]]=recognitionAll[ state.cohortUser[value][user]]
                        }
                        if(alignmentAll[ state.cohortUser[value][user]]){
                            alignment[state.cohortUser[value][user]]=alignmentAll[ state.cohortUser[value][user]]
                        }
                    }
          
                    commit('setRecognition', recognition)
                    commit('setAlignment', alignment)
                }
                
            }

            }
            
           
        },
        async getTeam1level({commit,rootState,dispatch,state}:any, value:any){
            let result={}
            await firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).get()
            .then((querySnapshot)=> {
                    querySnapshot.forEach((doc)=> {
                      const team_id=doc.data().team_id
                      result[team_id]=doc.data().parent
                    });
                commit('setOrganization', result)
            });
        },
        async changeTime({commit, dispatch, state,rootState} : any,value : any){
            commit('setloadings', true)
            // console.log('changeTime',value)
            let recognition = {}
            state.statusschedule=false
            let alignment={}
            let givenMember={}
            let receivedMember={}
            const alluser=rootState.main.allUser
            const team=rootState.main.allTeam
            
            if(value==''){
                value=state.time
            }else{
                state.statusTime=true
                state.time=value
            }
            let date=''
            const timezone = await getCompanyTimezone(rootState.authen.user.company)
            const companyNow = toCompanyDate(new Date(), timezone)
            if(value=='Past 30 days'){
                 //dispatch("calculateImpactRating", rootState.authen.user); 
                 date = format(addDays(companyNow, -30), 'YYYY-MM-DD')
            }else if(value=='Past 3 months'){
                //dispatch("calculateImpactRating",  rootState.authen.user); 
                 date = format(addDays(companyNow, -90), 'YYYY-MM-DD')
            }else{
                //dispatch("calculateImpactRating",  rootState.authen.user); 
                date = format(addDays(companyNow, -180), 'YYYY-MM-DD')
                state.statusTime=false
            }
            for(const data in state.dataAll){
                if(format(new Date( state.dataAll[data].date), 'YYYY-MM-DD')>=date){
                    const u = state.dataAll[data]
                    
                    u.dateFormatted = format(u.date, 'MMM DD, YYYY')
                    
                    if(state.tag=='All'){
                        if (u.statusrow == 'sendcoin') {
                            if(!givenMember[u.sender_email]){
                                givenMember[u.sender_email]=[]
                            }
                            if (u.type=='gem'){
                                u.hashtags=[]
                            }
                            if(u.core_value_ai){
                                if(!u.hashtags){
                                    u.hashtags=[]
                                }
                                let count=0
                                for(const i in u.core_value_ai){
                                    if(u.core_value_ai[i].rating>4){
                                        u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
                                        count++
                                    }else{
                                        if(u.hashtag_prev){
                                            u.hashtags[count]={name:u.hashtag_prev[count],rating:u.core_value_ai[i].rating}
                                        }else{
                                            u.hashtags[count]={name:'',rating:u.core_value_ai[i].rating}
                                        }
                                    }
                                    
                                }
                            }
                            givenMember[u.sender_email].push(u)
    
                            if(!receivedMember[u.send_to_email]){
                                receivedMember[u.send_to_email]=[]
                            }
                            receivedMember[u.send_to_email].push(u)
                            let emailKey=u.sender_email.replace(/\./g, '||')
                            if(alluser[emailKey]){
                                if (! recognition[u.sender_email]) {
                                    recognition[u.sender_email] = {
                                        key:u.id,
                                        email: u.sender_email,
                                        profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                        firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                        lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                        shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                        teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                        team_id:alluser[emailKey].team,
                                        impactRating:alluser[emailKey].impact_rating,
                                        tag:u.hashtag,
                                        date:u.date,
                                        given: 0,
                                        received: 0,
                                        ratio: '',
                                        sortRatio:0
                                    }
                                }
                            recognition[u.sender_email].given ++
    
                            }
                            emailKey=u.send_to_email.replace(/\./g, '||')
                            if(alluser[emailKey]){
                                if (! recognition[u.send_to_email]) {
                                const emailKey=u.send_to_email.replace(/\./g, '||')
                                recognition[u.send_to_email] = {
                                    key:u.id,
                                    email: u.send_to_email,
                                    profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                    firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                    lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                    shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                    teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                    team_id:alluser[emailKey].team,
                                    impactRating:alluser[emailKey].impact_rating,
                                    tag:u.hashtag,
                                    date:u.date,
                                    given: 0,
                                    received: 0,
                                    ratio: '',
                                    sortRatio:0,
                                    order_Ratio:0,
                                    order_Received:0,
                                    order_Given:0
                                }
                                }
                                recognition[u.send_to_email].received ++
                            }
                            if(u.core_value_ai){
                                emailKey=u.sender_email.replace(/\./g, '||')
                                if(alluser[emailKey]){
                                    if(!alignment[u.sender_email]){
                                        alignment[u.sender_email]={
                                            email: u.sender_email,
                                            profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                            firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                            lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                            shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                            teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                            team_id:alluser[emailKey].team,
                                            impactRating:alluser[emailKey].impact_rating,
                                            tag:u.hashtag,
                                            effortGiven:0,
                                            totalGiven:0,
                                            effortReceived:0,
                                            totalReceived:0,
                                            alignmentGiven:0,
                                            alignmentReceived:0,
                                            alignmentRatio:0,
                                            order_alignmentRatio:0,
                                            order_alignmentGiven:0,
                                            order_alignmentReceived:0}
                                    }
                                    
    
                                }
                                emailKey=u.send_to_email.replace(/\./g, '||')
                                if(alluser[emailKey]){
                                    if(!alignment[u.send_to_email]){
                                        //const emailKey=u.send_to_email.replace(/\./g, '||')
                                        alignment[u.send_to_email]={
                                            email: u.send_to_email,
                                            profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                            firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                            lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                            shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                            teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                            team_id:alluser[emailKey].team,
                                            effortGiven:0,
                                            totalGiven:0,
                                            effortReceived:0,
                                            totalReceived:0,
                                            impactRating:alluser[emailKey].impact_rating,
                                            alignmentGiven:0,
                                            alignmentReceived:0,
                                            alignmentRatio:0,
                                            order_alignmentRatio:0,
                                            order_alignmentGiven:0,
                                            order_alignmentReceived:0}
                                    }
                                    
                                }
                                // for(const i in u.core_value_ai){
                                //     if(u.core_value_ai[i].rating){
                                       
                                //         emailKey=u.sender_email.replace(/\./g, '||')
                                //         if(alluser[emailKey]){
                                //             alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+parseFloat(u.core_value_ai[i].rating)
                                //             alignment[u.sender_email].totalGiven++
                                //         }
                                //         emailKey=u.send_to_email.replace(/\./g, '||')
                                        
                                //         if(alluser[emailKey]){
                                //             alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+parseFloat(u.core_value_ai[i].rating)
                                //             alignment[u.send_to_email].totalReceived++
                                //         }
                                //     }
                                 
                                // }
                                let rating = 0;
                                let _rating = 0;
                                if(u.statusrow == 'sendcoin'){
                                    for(const i in u.core_value_ai){
                                        if(u.core_value_ai[i].rating){
                                           
                                            emailKey=u.sender_email.replace(/\./g, '||')
                                            if(alluser[emailKey]){
                                                if(_rating < parseFloat(u.core_value_ai[i].rating)){
                                                    _rating = parseFloat(u.core_value_ai[i].rating);
                                                }
                                                
                                            }
        
                                            emailKey=u.send_to_email.replace(/\./g, '||')
                                            
                                            if(alluser[emailKey]){
                                                if(rating < parseFloat(u.core_value_ai[i].rating)){
                                                    rating = parseFloat(u.core_value_ai[i].rating);
                                                }
                                                
                                            }
                                        }
                                     
                                    }
                                    emailKey=u.sender_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+_rating
                                        alignment[u.sender_email].totalGiven++
                                    }
                                    
                                    emailKey=u.send_to_email.replace(/\./g, '||')
                                    
                                    if(alluser[emailKey]){
                          
                                    alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+rating
                                    alignment[u.send_to_email].totalReceived++
                                    }
                                }
                                
                            }
                        }
                     

                    }else{

                        const findHashtag=_.find(u.hashtag, function(o) { return o == state.tag;});
                        if(findHashtag){
                            if (u.statusrow == 'sendcoin') {
                                if(!givenMember[u.sender_email]){
                                    givenMember[u.sender_email]=[]
                                }
                                if (u.type=='gem'){
                                    u.hashtags=[]
                                }
                                if(u.core_value_ai){
                                    if(!u.hashtags){
                                        u.hashtags=[]
                                    }
                                    let count=0
                                    for(const i in u.core_value_ai){
                                        if(u.core_value_ai[i].rating>4){
                                            u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
                                            count++
                                        }else{
                                            if(u.hashtag_prev){
                                                u.hashtags[count]={name:u.hashtag_prev[count],rating:u.core_value_ai[i].rating}
                                            }else{
                                                u.hashtags[count]={name:'',rating:u.core_value_ai[i].rating}
                                            }
                                        }
                                        
                                    }
                                }
                                givenMember[u.sender_email].push(u)
        
                                if(!receivedMember[u.send_to_email]){
                                    receivedMember[u.send_to_email]=[]
                                }
                                receivedMember[u.send_to_email].push(u)
                                let emailKey=u.sender_email.replace(/\./g, '||')
                                if(alluser[emailKey]){
                                    if (! recognition[u.sender_email]) {
                                        recognition[u.sender_email] = {
                                            key:u.id,
                                            email: u.sender_email,
                                            profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                            firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                            lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                            shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                            teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                            team_id:alluser[emailKey].team,
                                            impactRating:alluser[emailKey].impact_rating,
                                            tag:u.hashtag,
                                            date:u.date,
                                            given: 0,
                                            received: 0,
                                            ratio: '',
                                            sortRatio:0
                                        }
                                    }
                                recognition[u.sender_email].given ++
        
                                }
                                emailKey=u.send_to_email.replace(/\./g, '||')
                                if(alluser[emailKey]){
                                    if (! recognition[u.send_to_email]) {
                                    const emailKey=u.send_to_email.replace(/\./g, '||')
                                    recognition[u.send_to_email] = {
                                        key:u.id,
                                        email: u.send_to_email,
                                        profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                        firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                        lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                        shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                        teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                        team_id:alluser[emailKey].team,
                                        impactRating:alluser[emailKey].impact_rating,
                                        tag:u.hashtag,
                                        date:u.date,
                                        given: 0,
                                        received: 0,
                                        ratio: '',
                                        sortRatio:0,
                                        order_Ratio:0,
                                        order_Received:0,
                                        order_Given:0
                                    }
                                    }
                                    recognition[u.send_to_email].received ++
                                }
                                if(u.core_value_ai){
                                    emailKey=u.sender_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        if(!alignment[u.sender_email]){
                                            alignment[u.sender_email]={
                                                email: u.sender_email,
                                                profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                                firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                                lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                                shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                                teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                                team_id:alluser[emailKey].team,
                                                impactRating:alluser[emailKey].impact_rating,
                                                tag:u.hashtag,
                                                effortGiven:0,
                                                totalGiven:0,
                                                effortReceived:0,
                                                totalReceived:0,
                                                alignmentGiven:0,
                                                alignmentReceived:0,
                                                alignmentRatio:0}
                                        }
                                        
        
                                    }
                                    emailKey=u.send_to_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        if(!alignment[u.send_to_email]){
                                            //const emailKey=u.send_to_email.replace(/\./g, '||')
                                            alignment[u.send_to_email]={
                                                email: u.send_to_email,
                                                profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                                firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                                lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                                shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                                teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                                team_id:alluser[emailKey].team,
                                                effortGiven:0,totalGiven:0,effortReceived:0,totalReceived:0,
                                                alignmentGiven:0,
                                                impactRating:alluser[emailKey].impact_rating,
                                                alignmentReceived:0,
                                                alignmentRatio:0,
                                                order_alignmentRatio:0,
                                                order_alignmentGiven:0,
                                                order_alignmentReceived:0}
                                        }
                                        
                                    }
                                    // for(const i in u.core_value_ai){
                                    //     if(u.core_value_ai[i].rating){
                                           
                                    //         emailKey=u.sender_email.replace(/\./g, '||')
                                    //         if(alluser[emailKey]){
                                    //             alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+parseFloat(u.core_value_ai[i].rating)
                                    //             alignment[u.sender_email].totalGiven++
                                    //         }
                                    //         emailKey=u.send_to_email.replace(/\./g, '||')
                                            
                                    //         if(alluser[emailKey]){
                                    //             alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+parseFloat(u.core_value_ai[i].rating)
                                    //             alignment[u.send_to_email].totalReceived++
                                    //         }
                                    //     }
                                     
                                    // }
                                    let rating = 0;
                                let _rating = 0;
                                if(u.statusrow == 'sendcoin'){
                                    for(const i in u.core_value_ai){
                                        if(u.core_value_ai[i].rating){
                                           
                                            emailKey=u.sender_email.replace(/\./g, '||')
                                            if(alluser[emailKey]){
                                                if(_rating < parseFloat(u.core_value_ai[i].rating)){
                                                    _rating = parseFloat(u.core_value_ai[i].rating);
                                                }
                                                
                                            }
        
                                            emailKey=u.send_to_email.replace(/\./g, '||')
                                            
                                            if(alluser[emailKey]){
                                                if(rating < parseFloat(u.core_value_ai[i].rating)){
                                                    rating = parseFloat(u.core_value_ai[i].rating);
                                                }
                                                
                                            }
                                        }
                                     
                                    }
                                    emailKey=u.sender_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+_rating
                                        alignment[u.sender_email].totalGiven++
                                    }
                                    
                                    emailKey=u.send_to_email.replace(/\./g, '||')
                                    
                                    if(alluser[emailKey]){
                          
                                    alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+rating
                                    alignment[u.send_to_email].totalReceived++
                                    }
                                }
                                    
                                }
                            }
                        }

                    }
                    
                    
                }
            }
            for (const i in recognition) {
                if (recognition[i].received > 0) {
                    recognition[i].sortRatio=(recognition[i].given / recognition[i].received)
                    recognition[i].ratio = (recognition[i].given / recognition[i].received).toFixed(1)
                } else {
                    recognition[i].sortRatio=recognition[i].given
                    recognition[i].ratio = recognition[i].given.toFixed() + '*'
                }
                
            }
            for(const i in alignment){
                if(alignment[i].totalGiven>0){
                    alignment[i].alignmentGiven=isNaN(alignment[i].effortGiven/alignment[i].totalGiven)?0: (alignment[i].effortGiven/alignment[i].totalGiven).toFixed(1)
                }
                if(alignment[i].totalReceived>0){
                    alignment[i].alignmentReceived= isNaN(alignment[i].effortReceived/alignment[i].totalReceived)?0:(alignment[i].effortReceived/alignment[i].totalReceived).toFixed(1)
                }
                alignment[i].alignmentRatio= isNaN((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived))?0:((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived)).toFixed(1)
            }

            const given = _.orderBy(recognition, ['given'], ['desc'])
            const received = _.orderBy(recognition, ['received'], ['desc'])
            const sortRatio = _.orderBy(recognition, ['sortRatio'], ['desc'])
            let count=0
            let given_order=0
            for(const i in given){
              if(given_order!=recognition[given[i].email].given){
                given_order=recognition[given[i].email].given
                count++
                state.last_rank_given=count
              }
                recognition[given[i].email].order_Given=count
              if(count%10==1){
                recognition[given[i].email].orderGiven=count+'st'
              }else if(count%10==2){
                recognition[given[i].email].orderGiven=count+'nd'
              }else if(count%10==3){
                recognition[given[i].email].orderGiven=count+'rd'
              }else{
                recognition[given[i].email].orderGiven=count+'th'
              }
            }
            let count_received=0
            let received_order=0
            for(const i in received){
              if(received_order!=recognition[received[i].email].received){
                received_order=recognition[received[i].email].received
                count_received++
                state.last_rank_received=count_received
              }
              recognition[received[i].email].order_Received=count_received
              if(count_received%10==1){
                recognition[received[i].email].orderReceived=count_received+'st'
              }else if(count_received%10==2){
                recognition[received[i].email].orderReceived=count_received+'nd'
              }else if(count_received%10==3){
                recognition[ received[i].email].orderReceived=count_received+'rd'
              }else{
                recognition[ received[i].email].orderReceived=count_received+'th'
              }

              
            }
            let count_ratio=0
            let ratio_order=0
            for(const i in sortRatio){
              if(ratio_order!=recognition[sortRatio[i].email].sortRatio){
                ratio_order=recognition[sortRatio[i].email].sortRatio
                count_ratio++
                state.last_rank_ratio=count_ratio
              }
              
              recognition[sortRatio[i].email].order_Ratio=count_ratio
              if(count_ratio%10==1){
                recognition[sortRatio[i].email].orderRatio=count_ratio+'st'
              }else if(count_ratio%10==2){
                recognition[sortRatio[i].email].orderRatio=count_ratio+'nd'
              }else if(count_ratio%10==3){
                recognition[sortRatio[i].email].orderRatio=count_ratio+'rd'
              }else{
                recognition[sortRatio[i].email].orderRatio=count_ratio+'th'
              }
            }
            const alignmentGiven = _.orderBy(alignment, ['alignmentGiven'], ['desc'])
            const alignmentReceived = _.orderBy(alignment, ['alignmentReceived'], ['desc'])
            const alignmentRatio = _.orderBy(alignment, ['alignmentRatio'], ['desc'])
            let count_alignmentGiven=0
            let alignmentGiven_order=0
            for(const i in alignmentGiven){
                if(alignmentGiven_order!=alignment[alignmentGiven[i].email].alignmentGiven){
                  alignmentGiven_order=alignment[alignmentGiven[i].email].alignmentGiven
                  count_alignmentGiven++
                }
                    alignment[alignmentGiven[i].email].order_alignmentGiven=count_alignmentGiven
            }

            let count_alignmentReceived=0
            let alignmentReceived_order=0
            for(const i in alignmentReceived){
                if(alignmentReceived_order!=alignment[alignmentReceived[i].email].alignmentReceived){
                    alignmentReceived_order=alignment[alignmentReceived[i].email].alignmentReceived
                  count_alignmentReceived++
                }
                    alignment[alignmentReceived[i].email].order_alignmentReceived=count_alignmentReceived
            }
            let count_alignmentRatio=0
            let alignmentRatio_order=0
            for(const i in alignmentRatio){
                if(alignmentRatio_order!=alignment[alignmentRatio[i].email].alignmentRatio){
                    alignmentRatio_order=alignment[alignmentRatio[i].email].alignmentRatio
                    count_alignmentRatio++
                }
                    alignment[alignmentRatio[i].email].order_alignmentRatio=count_alignmentRatio
            }

        
            commit('setGivenMember', givenMember)
            commit('setReceivedMember', receivedMember)
           commit('setRecognition', recognition)
           commit('setAlignment', alignment)
           commit('setRecognitionAll', recognition)
           commit('setAlignmentAll', alignment)
           if(state.statusTeam){
                dispatch('changeTeam',state.statusTeam).then(()=>{
                    commit('setloadings', false)
                })
           }else{
            commit('setloadings', false)
           }
        },
        async changeTimeScedule({commit, dispatch, state,rootState} : any,value : any){
            commit('setloadings', true)
            // console.log('changeTime',value)
            const timezone = await getCompanyTimezone(rootState.authen.user.company)
            const companyNow = toCompanyDate(new Date(), timezone)
            const currentDateStart =format(addDays(companyNow, -180), 'YYYY-MM-DD')
            const currentDateEnd =format(companyNow, 'YYYY-MM-DD')
            const startDate =format(new Date(value[0]), 'YYYY-MM-DD');
            const endDate = format(new Date(value[1]), 'YYYY-MM-DD');
            state.startDate=startDate
            state.endDate=endDate
            state.statusschedule=true
            let recognition = {}
            let alignment={}
            let givenMember={}
            let receivedMember={}
            const alluser=rootState.main.allUser
            const team=rootState.main.allTeam
            
            if(value==''){
                value=state.time
            }else{
                state.statusTime=true
                state.time=value
            }
            if(currentDateStart>=startDate&&endDate<=currentDateEnd){
                state.statusnotpast6month=true
                dispatch("changeTimeData", value).then(()=>{
                    if(state.tag!='All'){
                        dispatch('filtersReconition',state.tag)
                    }
                   
                })
            }else{
                state.statusnotpast6month=false
                for(const data in state.dataAll){
                    if(format(new Date( state.dataAll[data].date), 'YYYY-MM-DD')>=startDate&&format(new Date( state.dataAll[data].date), 'YYYY-MM-DD')<=endDate){
                        const u = state.dataAll[data]
                        
                        u.dateFormatted = format(u.date, 'MMM DD, YYYY')
                        
                        if(state.tag=='All'){
                            if (u.statusrow == 'sendcoin') {
                                if(!givenMember[u.sender_email]){
                                    givenMember[u.sender_email]=[]
                                }
                                if (u.type=='gem'){
                                    u.hashtags=[]
                                }
                                if(u.core_value_ai){
                                    if(!u.hashtags){
                                        u.hashtags=[]
                                    }
                                    let count=0
                                    for(const i in u.core_value_ai){
                                        if(u.core_value_ai[i].rating>4){
                                            u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
                                            count++
                                        }else{
                                            if(u.hashtag_prev){
                                                u.hashtags[count]={name:u.hashtag_prev[count],rating:u.core_value_ai[i].rating}
                                            }else{
                                                u.hashtags[count]={name:'',rating:u.core_value_ai[i].rating}
                                            }
                                        }
                                        
                                    }
                                }
                                givenMember[u.sender_email].push(u)
        
                                if(!receivedMember[u.send_to_email]){
                                    receivedMember[u.send_to_email]=[]
                                }
                                receivedMember[u.send_to_email].push(u)
                                let emailKey=u.sender_email.replace(/\./g, '||')
                                if(alluser[emailKey]){
                                    if (! recognition[u.sender_email]) {
                                        recognition[u.sender_email] = {
                                            key:u.id,
                                            email: u.sender_email,
                                            profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                            firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                            lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                            shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                            teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                            team_id:alluser[emailKey].team,
                                            impactRating:alluser[emailKey].impact_rating,
                                            tag:u.hashtag,
                                            date:u.date,
                                            given: 0,
                                            received: 0,
                                            ratio: '',
                                            sortRatio:0
                                        }
                                    }
                                recognition[u.sender_email].given ++
        
                                }
                                emailKey=u.send_to_email.replace(/\./g, '||')
                                if(alluser[emailKey]){
                                    if (! recognition[u.send_to_email]) {
                                    const emailKey=u.send_to_email.replace(/\./g, '||')
                                    recognition[u.send_to_email] = {
                                        key:u.id,
                                        email: u.send_to_email,
                                        profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                        firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                        lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                        shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                        teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                        team_id:alluser[emailKey].team,
                                        impactRating:alluser[emailKey].impact_rating,
                                        tag:u.hashtag,
                                        date:u.date,
                                        given: 0,
                                        received: 0,
                                        ratio: '',
                                        sortRatio:0,
                                        order_Ratio:0,
                                        order_Received:0,
                                        order_Given:0
                                    }
                                    }
                                    recognition[u.send_to_email].received ++
                                }
                                if(u.core_value_ai){
                                    emailKey=u.sender_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        if(!alignment[u.sender_email]){
                                            alignment[u.sender_email]={
                                                email: u.sender_email,
                                                profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                                firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                                lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                                shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                                teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                                team_id:alluser[emailKey].team,
                                                impactRating:alluser[emailKey].impact_rating,
                                                tag:u.hashtag,
                                                effortGiven:0,
                                                totalGiven:0,
                                                effortReceived:0,
                                                totalReceived:0,
                                                alignmentGiven:0,
                                                alignmentReceived:0,
                                                alignmentRatio:0}
                                        }
                                        
        
                                    }
                                    emailKey=u.send_to_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        if(!alignment[u.send_to_email]){
                                            //const emailKey=u.send_to_email.replace(/\./g, '||')
                                            alignment[u.send_to_email]={
                                                email: u.send_to_email,
                                                profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                                firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                                lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                                shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                                teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                                team_id:alluser[emailKey].team,
                                                effortGiven:0,
                                                totalGiven:0,
                                                effortReceived:0,
                                                totalReceived:0,
                                                impactRating:alluser[emailKey].impact_rating,
                                                alignmentGiven:0,
                                                alignmentReceived:0,
                                                alignmentRatio:0,
                                                order_alignmentRatio:0,
                                                order_alignmentGiven:0,
                                                order_alignmentReceived:0}
                                        }
                                        
                                    }
                                    // for(const i in u.core_value_ai){
                                    //     if(u.core_value_ai[i].rating){
                                           
                                    //         emailKey=u.sender_email.replace(/\./g, '||')
                                    //         if(alluser[emailKey]){
                                    //             alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+parseFloat(u.core_value_ai[i].rating)
                                    //             alignment[u.sender_email].totalGiven++
                                    //         }
                                    //         emailKey=u.send_to_email.replace(/\./g, '||')
                                            
                                    //         if(alluser[emailKey]){
                                    //             alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+parseFloat(u.core_value_ai[i].rating)
                                    //             alignment[u.send_to_email].totalReceived++
                                    //         }
                                    //     }
                                     
                                    // }
                                    let rating = 0;
                                let _rating = 0;
                                if(u.statusrow == 'sendcoin'){
                                    for(const i in u.core_value_ai){
                                        if(u.core_value_ai[i].rating){
                                           
                                            emailKey=u.sender_email.replace(/\./g, '||')
                                            if(alluser[emailKey]){
                                                if(_rating < parseFloat(u.core_value_ai[i].rating)){
                                                    _rating = parseFloat(u.core_value_ai[i].rating);
                                                }
                                                
                                            }
        
                                            emailKey=u.send_to_email.replace(/\./g, '||')
                                            
                                            if(alluser[emailKey]){
                                                if(rating < parseFloat(u.core_value_ai[i].rating)){
                                                    rating = parseFloat(u.core_value_ai[i].rating);
                                                }
                                                
                                            }
                                        }
                                     
                                    }
                                    emailKey=u.sender_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+_rating
                                        alignment[u.sender_email].totalGiven++
                                    }
                                    
                                    emailKey=u.send_to_email.replace(/\./g, '||')
                                    
                                    if(alluser[emailKey]){
                          
                                    alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+rating
                                    alignment[u.send_to_email].totalReceived++
                                    }
                                }
                                    
                                }
                            }
                         
    
                        }else{
    
                            const findHashtag=_.find(u.hashtag, function(o) { return o == state.tag;});
                            if(findHashtag){
                                if (u.statusrow == 'sendcoin' ) {
                                    if(!givenMember[u.sender_email]){
                                        givenMember[u.sender_email]=[]
                                    }
                                    if (u.type=='gem'){
                                        u.hashtags=[]
                                    }
                                    if(u.core_value_ai){
                                        if(!u.hashtags){
                                            u.hashtags=[]
                                        }
                                        let count=0
                                        for(const i in u.core_value_ai){
                                            if(u.core_value_ai[i].rating>4){
                                                u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
                                                count++
                                            }else{
                                                if(u.hashtag_prev){
                                                    u.hashtags[count]={name:u.hashtag_prev[count],rating:u.core_value_ai[i].rating}
                                                }else{
                                                    u.hashtags[count]={name:'',rating:u.core_value_ai[i].rating}
                                                }
                                            }
                                            
                                        }
                                    }
                                    givenMember[u.sender_email].push(u)
            
                                    if(!receivedMember[u.send_to_email]){
                                        receivedMember[u.send_to_email]=[]
                                    }
                                    receivedMember[u.send_to_email].push(u)
                                    let emailKey=u.sender_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        if (! recognition[u.sender_email]) {
                                            recognition[u.sender_email] = {
                                                key:u.id,
                                                email: u.sender_email,
                                                profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                                firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                                lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                                shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                                teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                                team_id:alluser[emailKey].team,
                                                impactRating:alluser[emailKey].impact_rating,
                                                tag:u.hashtag,
                                                date:u.date,
                                                given: 0,
                                                received: 0,
                                                ratio: '',
                                                sortRatio:0
                                            }
                                        }
                                    recognition[u.sender_email].given ++
            
                                    }
                                    emailKey=u.send_to_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        if (! recognition[u.send_to_email]) {
                                        const emailKey=u.send_to_email.replace(/\./g, '||')
                                        recognition[u.send_to_email] = {
                                            key:u.id,
                                            email: u.send_to_email,
                                            profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                            firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                            lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                            shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                            teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                            team_id:alluser[emailKey].team,
                                            impactRating:alluser[emailKey].impact_rating,
                                            tag:u.hashtag,
                                            date:u.date,
                                            given: 0,
                                            received: 0,
                                            ratio: '',
                                            sortRatio:0,
                                            order_Ratio:0,
                                            order_Received:0,
                                            order_Given:0
                                        }
                                        }
                                        recognition[u.send_to_email].received ++
                                    }
                                    if(u.core_value_ai){
                                        emailKey=u.sender_email.replace(/\./g, '||')
                                        if(alluser[emailKey]){
                                            if(!alignment[u.sender_email]){
                                                alignment[u.sender_email]={
                                                    email: u.sender_email,
                                                    profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                                    firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                                    lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                                    shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                                    teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                                    team_id:alluser[emailKey].team,
                                                    impactRating:alluser[emailKey].impact_rating,
                                                    tag:u.hashtag,
                                                    effortGiven:0,
                                                    totalGiven:0,
                                                    effortReceived:0,
                                                    totalReceived:0,
                                                    alignmentGiven:0,
                                                    alignmentReceived:0,
                                                    alignmentRatio:0}
                                            }
                                            
            
                                        }
                                        emailKey=u.send_to_email.replace(/\./g, '||')
                                        if(alluser[emailKey]){
                                            if(!alignment[u.send_to_email]){
                                                //const emailKey=u.send_to_email.replace(/\./g, '||')
                                                alignment[u.send_to_email]={
                                                    email: u.send_to_email,
                                                    profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                                    firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                                    lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                                    shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                                    teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                                    team_id:alluser[emailKey].team,
                                                    effortGiven:0,totalGiven:0,effortReceived:0,totalReceived:0,
                                                    alignmentGiven:0,
                                                    impactRating:alluser[emailKey].impact_rating,
                                                    alignmentReceived:0,
                                                    alignmentRatio:0,
                                                    order_alignmentRatio:0,
                                                    order_alignmentGiven:0,
                                                    order_alignmentReceived:0}
                                            }
                                            
                                        }
                                        // for(const i in u.core_value_ai){
                                        //     if(u.core_value_ai[i].rating){
                                               
                                        //         emailKey=u.sender_email.replace(/\./g, '||')
                                        //         if(alluser[emailKey]){
                                        //             alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+parseFloat(u.core_value_ai[i].rating)
                                        //             alignment[u.sender_email].totalGiven++
                                        //         }
                                        //         emailKey=u.send_to_email.replace(/\./g, '||')
                                                
                                        //         if(alluser[emailKey]){
                                        //             alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+parseFloat(u.core_value_ai[i].rating)
                                        //             alignment[u.send_to_email].totalReceived++
                                        //         }
                                        //     }
                                         
                                        // }
                                        let rating = 0;
                                let _rating = 0;
                                if(u.statusrow == 'sendcoin'){
                                    for(const i in u.core_value_ai){
                                        if(u.core_value_ai[i].rating){
                                           
                                            emailKey=u.sender_email.replace(/\./g, '||')
                                            if(alluser[emailKey]){
                                                if(_rating < parseFloat(u.core_value_ai[i].rating)){
                                                    _rating = parseFloat(u.core_value_ai[i].rating);
                                                }
                                                
                                            }
        
                                            emailKey=u.send_to_email.replace(/\./g, '||')
                                            
                                            if(alluser[emailKey]){
                                                if(rating < parseFloat(u.core_value_ai[i].rating)){
                                                    rating = parseFloat(u.core_value_ai[i].rating);
                                                }
                                                
                                            }
                                        }
                                     
                                    }
                                    emailKey=u.sender_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+_rating
                                        alignment[u.sender_email].totalGiven++
                                    }
                                    
                                    emailKey=u.send_to_email.replace(/\./g, '||')
                                    
                                    if(alluser[emailKey]){
                          
                                    alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+rating
                                    alignment[u.send_to_email].totalReceived++
                                    }
                                }
                                        
                                    }
                                }
                            }
    
                        }
                        
                        
                    }
                }
                for (const i in recognition) {
                    if (recognition[i].received > 0) {
                        recognition[i].sortRatio=(recognition[i].given / recognition[i].received)
                        recognition[i].ratio = (recognition[i].given / recognition[i].received).toFixed(1)
                    } else {
                        recognition[i].sortRatio=recognition[i].given
                        recognition[i].ratio = recognition[i].given.toFixed() + '*'
                    }
                    
                }
                for(const i in alignment){
                    if(alignment[i].totalGiven>0){
                        alignment[i].alignmentGiven=isNaN(alignment[i].effortGiven/alignment[i].totalGiven)?0: (alignment[i].effortGiven/alignment[i].totalGiven).toFixed(1)
                    }
                    if(alignment[i].totalReceived>0){
                        alignment[i].alignmentReceived= isNaN(alignment[i].effortReceived/alignment[i].totalReceived)?0:(alignment[i].effortReceived/alignment[i].totalReceived).toFixed(1)
                    }
                    alignment[i].alignmentRatio= isNaN((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived))?0:((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived)).toFixed(1)
                }
    
    
                const given = _.orderBy(recognition, ['given'], ['desc'])
                const received = _.orderBy(recognition, ['received'], ['desc'])
                const sortRatio = _.orderBy(recognition, ['sortRatio'], ['desc'])
                let count=0
                let given_order=0
                for(const i in given){
                  if(given_order!=recognition[given[i].email].given){
                    given_order=recognition[given[i].email].given
                    count++
                    state.last_rank_given=count
                  }
                    recognition[given[i].email].order_Given=count
                  if(count%10==1){
                    recognition[given[i].email].orderGiven=count+'st'
                  }else if(count%10==2){
                    recognition[given[i].email].orderGiven=count+'nd'
                  }else if(count%10==3){
                    recognition[given[i].email].orderGiven=count+'rd'
                  }else{
                    recognition[given[i].email].orderGiven=count+'th'
                  }
                }
                let count_received=0
                let received_order=0
                for(const i in received){
                  if(received_order!=recognition[received[i].email].received){
                    received_order=recognition[received[i].email].received
                    count_received++
                    state.last_rank_received=count_received
                  }
                  recognition[received[i].email].order_Received=count_received
                  if(count_received%10==1){
                    recognition[received[i].email].orderReceived=count_received+'st'
                  }else if(count_received%10==2){
                    recognition[received[i].email].orderReceived=count_received+'nd'
                  }else if(count_received%10==3){
                    recognition[ received[i].email].orderReceived=count_received+'rd'
                  }else{
                    recognition[ received[i].email].orderReceived=count_received+'th'
                  }
    
                  
                }
                let count_ratio=0
                let ratio_order=0
                for(const i in sortRatio){
                  if(ratio_order!=recognition[sortRatio[i].email].sortRatio){
                    ratio_order=recognition[sortRatio[i].email].sortRatio
                    count_ratio++
                    state.last_rank_ratio=count_ratio
                  }
                  
                  recognition[sortRatio[i].email].order_Ratio=count_ratio
                  if(count_ratio%10==1){
                    recognition[sortRatio[i].email].orderRatio=count_ratio+'st'
                  }else if(count_ratio%10==2){
                    recognition[sortRatio[i].email].orderRatio=count_ratio+'nd'
                  }else if(count_ratio%10==3){
                    recognition[sortRatio[i].email].orderRatio=count_ratio+'rd'
                  }else{
                    recognition[sortRatio[i].email].orderRatio=count_ratio+'th'
                  }
                }
                const alignmentGiven = _.orderBy(alignment, ['alignmentGiven'], ['desc'])
                const alignmentReceived = _.orderBy(alignment, ['alignmentReceived'], ['desc'])
                const alignmentRatio = _.orderBy(alignment, ['alignmentRatio'], ['desc'])
                let count_alignmentGiven=0
                let alignmentGiven_order=0
                for(const i in alignmentGiven){
                    if(alignmentGiven_order!=alignment[alignmentGiven[i].email].alignmentGiven){
                      alignmentGiven_order=alignment[alignmentGiven[i].email].alignmentGiven
                      count_alignmentGiven++
                    }
                        alignment[alignmentGiven[i].email].order_alignmentGiven=count_alignmentGiven
                }
    
                let count_alignmentReceived=0
                let alignmentReceived_order=0
                for(const i in alignmentReceived){
                    if(alignmentReceived_order!=alignment[alignmentReceived[i].email].alignmentReceived){
                        alignmentReceived_order=alignment[alignmentReceived[i].email].alignmentReceived
                      count_alignmentReceived++
                    }
                        alignment[alignmentReceived[i].email].order_alignmentReceived=count_alignmentReceived
                }
                let count_alignmentRatio=0
                let alignmentRatio_order=0
                for(const i in alignmentRatio){
                    if(alignmentRatio_order!=alignment[alignmentRatio[i].email].alignmentRatio){
                        alignmentRatio_order=alignment[alignmentRatio[i].email].alignmentRatio
                        count_alignmentRatio++
                    }
                        alignment[alignmentRatio[i].email].order_alignmentRatio=count_alignmentRatio
                }
    
     
                commit('setGivenMember', givenMember)
                commit('setReceivedMember', receivedMember)
               commit('setRecognition', recognition)
               commit('setAlignment', alignment)
               commit('setRecognitionAll', recognition)
               commit('setAlignmentAll', alignment)
               if(state.statusTeam){
                    dispatch('changeTeam',state.statusTeam).then(()=>{
                        commit('setloadings', false)
                    })
               }else{
                commit('setloadings', false)
               }

            }

        },
        async filtersReconition({commit, dispatch, state,rootState} : any,value : any){
            
            commit('setloadings', true)
            const timezone = await getCompanyTimezone(rootState.authen.user.company)
            const companyNow = toCompanyDate(new Date(), timezone)
            let recognitionAll:any=[]
            let alignmentAll:any=[]
            let recognition = {}
            let givenMember={}
            let receivedMember={}
            let alignment={}
            recognitionAll=state.recognitionAll
            alignmentAll=state.alignmentAll
            const alluser=rootState.main.allUser
            const team=rootState.main.allTeam
            state.tag=value
            let date=''
            let enddate=''
            if(state.statusschedule==true){
                date= format(new Date(state.startDate), 'YYYY-MM-DD')
                enddate= format(new Date(state.endDate), 'YYYY-MM-DD')
            }else{
                enddate= format(companyNow, 'YYYY-MM-DD')
                if(state.time=='Past 30 days'){
                    date = format(addDays(companyNow, -30), 'YYYY-MM-DD')
               }else if(state.time=='Past 3 months'){
                    date = format(addDays(companyNow, -90), 'YYYY-MM-DD')
               }else{
                    date = format(addDays(companyNow, -180), 'YYYY-MM-DD')
               }
                
            }
            if(state.statusnotpast6month==true){
               
                for(const data in state.dataAllnotpast6month){
                   
                        const u = state.dataAllnotpast6month[data]
                        if(value=='All'){
                            u.dateFormatted = format(u.date, 'MMM DD, YYYY')
                            if (u.statusrow == 'sendcoin' ) {
                                if(!givenMember[u.sender_email]){
                                    givenMember[u.sender_email]=[]
                                }
                                givenMember[u.sender_email].push(u)
            
                                if(!receivedMember[u.send_to_email]){
                                    receivedMember[u.send_to_email]=[]
                                }
                                receivedMember[u.send_to_email].push(u)
                                if (u.type=='gem'){
                                    u.hashtags=[]
                                }
                                if(u.core_value_ai){
                                    if(!u.hashtags){
                                        u.hashtags=[]
                                    }
                                    let count=0
                                    for(const i in u.core_value_ai){
                                        if(u.core_value_ai[i].rating>4){
                                            u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
                                            count++
                                        }else{
                                            if(u.hashtag_prev){
                                                u.hashtags[count]={name:u.hashtag_prev[count],rating:u.core_value_ai[i].rating}
                                            }else{
                                                u.hashtags[count]={name:'',rating:u.core_value_ai[i].rating}
                                            }
                                        }
                                        
                                    }
                                }
                                let emailKey=u.sender_email.replace(/\./g, '||')
                                if(alluser[emailKey]){
                                    if (! recognition[u.sender_email]) {
                                        recognition[u.sender_email] = {
                                            key:u.id,
                                            email: u.sender_email,
                                            profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                            firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                            lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                            shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                            teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                            team_id:alluser[emailKey].team,
                                            impactRating:alluser[emailKey].impact_rating,
                                            tag:u.hashtag,
                                            date:u.date,
                                            given: 0,
                                            received: 0,
                                            ratio: '',
                                            sortRatio:0
                                        }
                                    }
                                recognition[u.sender_email].given ++
            
                                }
                                emailKey=u.send_to_email.replace(/\./g, '||')
                                if(alluser[emailKey]){
                                    if (! recognition[u.send_to_email]) {
                                    const emailKey=u.send_to_email.replace(/\./g, '||')
                                    recognition[u.send_to_email] = {
                                        key:u.id,
                                        email: u.send_to_email,
                                        profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                        firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                        lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                        shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                        teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                        team_id:alluser[emailKey].team,
                                        impactRating:alluser[emailKey].impact_rating,
                                        tag:u.hashtag,
                                        date:u.date,
                                        given: 0,
                                        received: 0,
                                        ratio: '',
                                        sortRatio:0,
                                        order_Ratio:0,
                                        order_Received:0,
                                        order_Given:0
                                    }
                                    }
                                    recognition[u.send_to_email].received ++
                                }
                                if(u.core_value_ai){
                                    emailKey=u.sender_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        if(!alignment[u.sender_email]){
                                            alignment[u.sender_email]={
                                                email: u.sender_email,
                                                profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                                firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                                lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                                shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                                teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                                team_id:alluser[emailKey].team,
                                                impactRating:alluser[emailKey].impact_rating,
                                                tag:u.hashtag,
                                                effortGiven:0,
                                                totalGiven:0,
                                                effortReceived:0,
                                                totalReceived:0,
                                                alignmentGiven:0,
                                                alignmentReceived:0,
                                                alignmentRatio:0}
                                        }
                                        
        
                                    }
                                    emailKey=u.send_to_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        if(!alignment[u.send_to_email]){
                                            //const emailKey=u.send_to_email.replace(/\./g, '||')
                                            alignment[u.send_to_email]={
                                                email: u.send_to_email,
                                                profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                                firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                                lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                                shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                                teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                                effortGiven:0,totalGiven:0,effortReceived:0,totalReceived:0,
                                                team_id:alluser[emailKey].team,
                                                impactRating:alluser[emailKey].impact_rating,
                                                alignmentGiven:0,
                                                alignmentReceived:0,
                                                alignmentRatio:0,
                                                order_alignmentRatio:0,
                                                order_alignmentGiven:0,
                                                order_alignmentReceived:0}
                                        }
                                        
                                    }
                                    // for(const i in u.core_value_ai){
                                    //     if(u.core_value_ai[i].rating){
                                           
                                    //         emailKey=u.sender_email.replace(/\./g, '||')
                                    //         if(alluser[emailKey]){
                                    //             alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+parseFloat(u.core_value_ai[i].rating)
                                    //             alignment[u.sender_email].totalGiven++
                                    //         }
                                    //         emailKey=u.send_to_email.replace(/\./g, '||')
                                            
                                    //         if(alluser[emailKey]){
                                    //             alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+parseFloat(u.core_value_ai[i].rating)
                                    //             alignment[u.send_to_email].totalReceived++
                                    //         }
                                    //     }
                                     
                                    // }
                                let rating = 0;
                                let _rating = 0;
                                if(u.statusrow == 'sendcoin'){
                                    for(const i in u.core_value_ai){
                                        if(u.core_value_ai[i].rating){
                                           
                                            emailKey=u.sender_email.replace(/\./g, '||')
                                            if(alluser[emailKey]){
                                                if(_rating < parseFloat(u.core_value_ai[i].rating)){
                                                    _rating = parseFloat(u.core_value_ai[i].rating);
                                                }
                                                
                                            }
        
                                            emailKey=u.send_to_email.replace(/\./g, '||')
                                            
                                            if(alluser[emailKey]){
                                                if(rating < parseFloat(u.core_value_ai[i].rating)){
                                                    rating = parseFloat(u.core_value_ai[i].rating);
                                                }
                                                
                                            }
                                        }
                                     
                                    }
                                    emailKey=u.sender_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+_rating
                                        alignment[u.sender_email].totalGiven++
                                    }
                                    
                                    emailKey=u.send_to_email.replace(/\./g, '||')
                                    
                                    if(alluser[emailKey]){
                          
                                    alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+rating
                                    alignment[u.send_to_email].totalReceived++
                                    }
                                }
                                    
                                }
                            }
                        }else{
                           let status_hashtag=false
                            const findHashtag=_.find(u.hashtag, function(o) { return o == value; });
                             if(findHashtag){
                                u.dateFormatted = format(u.date, 'MMM DD, YYYY')
                                if(u.core_value_ai){
                                    for(const i in u.core_value_ai){
                                        if(u.core_value_ai[i].rating){
                                            if(value==u.hashtag[i]){
                                                status_hashtag=true
                                            }

                                        }
                                    }
                                }
                            if (u.statusrow == 'sendcoin' &&status_hashtag) {
                                if (u.type=='gem'){
                                    u.hashtags=[]
                                }
                                if(!givenMember[u.sender_email]){
                                    givenMember[u.sender_email]=[]
                                }
                                givenMember[u.sender_email].push(u)
                                if(!receivedMember[u.send_to_email]){
                                    receivedMember[u.send_to_email]=[]
                                }
                                
                                receivedMember[u.send_to_email].push(u)
                                if(u.core_value_ai){
                                    if(!u.hashtags){
                                        u.hashtags=[]
                                    }
                                    let count=0
                                    for(const i in u.core_value_ai){
                                        if(u.core_value_ai[i].rating>4){
                                            u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
                                            count++
                                        }else{
                                            if(u.hashtag_prev){
                                                u.hashtags[count]={name:u.hashtag_prev[count],rating:u.core_value_ai[i].rating}
                                            }else{
                                                u.hashtags[count]={name:'',rating:u.core_value_ai[i].rating}
                                            }
                                        }
                                        
                                    }
                                }
                                let emailKey=u.sender_email.replace(/\./g, '||')
                                if(alluser[emailKey]){
                                    if (! recognition[u.sender_email]) {
                                        recognition[u.sender_email] = {
                                            key:u.id,
                                            email: u.sender_email,
                                            profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                            firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                            lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                            shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                            teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                            team_id:alluser[emailKey].team,
                                            impactRating:alluser[emailKey].impact_rating,
                                            tag:u.hashtag,
                                            date:u.date,
                                            given: 0,
                                            received: 0,
                                            ratio: '',
                                            sortRatio:0
                                        }
                                    }
                                recognition[u.sender_email].given ++
            
                                }
                                emailKey=u.send_to_email.replace(/\./g, '||')
                                if(alluser[emailKey]){
                                    if (! recognition[u.send_to_email]) {
                                    const emailKey=u.send_to_email.replace(/\./g, '||')
                                    recognition[u.send_to_email] = {
                                        key:u.id,
                                        email: u.send_to_email,
                                        profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                        firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                        lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                        shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                        teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                        team_id:alluser[emailKey].team,
                                        impactRating:alluser[emailKey].impact_rating,
                                        tag:u.hashtag,
                                        date:u.date,
                                        given: 0,
                                        received: 0,
                                        ratio: '',
                                        sortRatio:0,
                                        order_Ratio:0,
                                        order_Received:0,
                                        order_Given:0
                                    }
                                    }
                                    recognition[u.send_to_email].received ++
                                }
                                if(u.core_value_ai){
                                    emailKey=u.sender_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        if(!alignment[u.sender_email]){
                                            alignment[u.sender_email]={
                                                email: u.sender_email,
                                                profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                                firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                                lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                                shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                                teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                                team_id:alluser[emailKey].team,
                                                impactRating:alluser[emailKey].impact_rating,
                                                tag:u.hashtag,
                                                effortGiven:0,
                                                totalGiven:0,
                                                effortReceived:0,
                                                totalReceived:0,
                                                alignmentGiven:0,
                                                alignmentReceived:0,
                                                alignmentRatio:0}
                                        }
                                        
        
                                    }
                                    emailKey=u.send_to_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        if(!alignment[u.send_to_email]){
                                            //const emailKey=u.send_to_email.replace(/\./g, '||')
                                            alignment[u.send_to_email]={
                                                email: u.send_to_email,
                                                profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                                firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                                lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                                shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                                teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                                team_id:alluser[emailKey].team,
                                                effortGiven:0,
                                                totalGiven:0,
                                                effortReceived:0,
                                                totalReceived:0,
                                                impactRating:alluser[emailKey].impact_rating,
                                                alignmentGiven:0,
                                                alignmentReceived:0,
                                                alignmentRatio:0,
                                                order_alignmentRatio:0,
                                                order_alignmentGiven:0,
                                                order_alignmentReceived:0}
                                        }
                                        
                                    }
                                    // for(const i in u.core_value_ai){
                                    //     if(u.core_value_ai[i].rating){
                                           
                                    //         emailKey=u.sender_email.replace(/\./g, '||')
                                    //         if(alluser[emailKey]){
                                    //             alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+parseFloat(u.core_value_ai[i].rating)
                                    //             alignment[u.sender_email].totalGiven++
                                    //         }
                                    //         emailKey=u.send_to_email.replace(/\./g, '||')
                                            
                                    //         if(alluser[emailKey]){
                                    //             alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+parseFloat(u.core_value_ai[i].rating)
                                    //             alignment[u.send_to_email].totalReceived++
                                    //         }
                                    //     }
                                     
                                    // }
                                    let rating = 0;
                                let _rating = 0;
                                if(u.statusrow == 'sendcoin'){
                                    for(const i in u.core_value_ai){
                                        if(u.core_value_ai[i].rating){
                                           
                                            emailKey=u.sender_email.replace(/\./g, '||')
                                            if(alluser[emailKey]){
                                                if(_rating < parseFloat(u.core_value_ai[i].rating)){
                                                    _rating = parseFloat(u.core_value_ai[i].rating);
                                                }
                                                
                                            }
        
                                            emailKey=u.send_to_email.replace(/\./g, '||')
                                            
                                            if(alluser[emailKey]){
                                                if(rating < parseFloat(u.core_value_ai[i].rating)){
                                                    rating = parseFloat(u.core_value_ai[i].rating);
                                                }
                                                
                                            }
                                        }
                                     
                                    }
                                    emailKey=u.sender_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+_rating
                                        alignment[u.sender_email].totalGiven++
                                    }
                                    
                                    emailKey=u.send_to_email.replace(/\./g, '||')
                                    
                                    if(alluser[emailKey]){
                          
                                    alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+rating
                                    alignment[u.send_to_email].totalReceived++
                                    }
                                }
                                    
                                }
                            }
            
                            }
        
                        }
                     }   
                    
        
                    for (const i in recognition) {
                        if (recognition[i].received > 0) {
                            recognition[i].sortRatio=(recognition[i].given / recognition[i].received)
                            recognition[i].ratio = (recognition[i].given / recognition[i].received).toFixed(1)
                        } else {
                            recognition[i].sortRatio=recognition[i].given
                            recognition[i].ratio = recognition[i].given.toFixed() + '*'
                        }
                        
                    }
                    for(const i in alignment){
                        if(alignment[i].totalGiven>0){
                            alignment[i].alignmentGiven=isNaN(alignment[i].effortGiven/alignment[i].totalGiven)?0: (alignment[i].effortGiven/alignment[i].totalGiven).toFixed(1)
                        }
                        if(alignment[i].totalReceived>0){
                            alignment[i].alignmentReceived= isNaN(alignment[i].effortReceived/alignment[i].totalReceived)?0:(alignment[i].effortReceived/alignment[i].totalReceived).toFixed(1)
                        }
                        alignment[i].alignmentRatio= isNaN((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived))?0:((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived)).toFixed(1)
                    }
        
        
                    const given = _.orderBy(recognition, ['given'], ['desc'])
                    const received = _.orderBy(recognition, ['received'], ['desc'])
                    const sortRatio = _.orderBy(recognition, ['sortRatio'], ['desc'])
                    let count=0
                    let given_order=0
                    for(const i in given){
                      if(given_order!=recognition[given[i].email].given){
                        given_order=recognition[given[i].email].given
                        count++
                        state.last_rank_given=count
                      }
                        recognition[given[i].email].order_Given=count
                     
                    }
                    let count_received=0
                    let received_order=0
                    for(const i in received){
                      if(received_order!=recognition[received[i].email].received){
                        received_order=recognition[received[i].email].received
                        count_received++
                        state.last_rank_received=count_received
                      }
                      recognition[received[i].email].order_Received=count_received
                      
        
                      
                    }
                    let count_ratio=0
                    let ratio_order=0
                    for(const i in sortRatio){
                      if(ratio_order!=recognition[sortRatio[i].email].sortRatio){
                        ratio_order=recognition[sortRatio[i].email].sortRatio
                        count_ratio++
                        state.last_rank_ratio=count_ratio
                      }
                      
                      recognition[sortRatio[i].email].order_Ratio=count_ratio
                      
                    }
                    const alignmentGiven = _.orderBy(alignment, ['alignmentGiven'], ['desc'])
                    const alignmentReceived = _.orderBy(alignment, ['alignmentReceived'], ['desc'])
                    const alignmentRatio = _.orderBy(alignment, ['alignmentRatio'], ['desc'])
                    let count_alignmentGiven=0
                    let alignmentGiven_order=0
                    for(const i in alignmentGiven){
                        if(alignmentGiven_order!=alignment[alignmentGiven[i].email].alignmentGiven){
                          alignmentGiven_order=alignment[alignmentGiven[i].email].alignmentGiven
                          count_alignmentGiven++
                        }
                        
                            alignment[alignmentGiven[i].email].order_alignmentGiven=count_alignmentGiven
                    }
        
                    let count_alignmentReceived=0
                    let alignmentReceived_order=0
                    for(const i in alignmentReceived){
                        if(alignmentReceived_order!=alignment[alignmentReceived[i].email].alignmentReceived){
                            alignmentReceived_order=alignment[alignmentReceived[i].email].alignmentReceived
                          count_alignmentReceived++
                        }
                            alignment[alignmentReceived[i].email].order_alignmentReceived=count_alignmentReceived
                    }
                    let count_alignmentRatio=0
                    let alignmentRatio_order=0
                    for(const i in alignmentRatio){
                        if(alignmentRatio_order!=alignment[alignmentRatio[i].email].alignmentRatio){
                            alignmentRatio_order=alignment[alignmentRatio[i].email].alignmentRatio
                            count_alignmentRatio++
                        }
                            alignment[alignmentRatio[i].email].order_alignmentRatio=count_alignmentRatio
                    }
        
                    commit('setGivenMember', givenMember)
                    commit('setReceivedMember', receivedMember)
                    await commit('setRecognition', recognition)
                    await commit('setAlignment', alignment)
                    await commit('setRecognitionAll', recognition)
                    await commit('setAlignmentAll', alignment)
                    if(state.statusTeam){
                            dispatch('changeTeam',state.statusTeam).then(()=>{
                                commit('setloadings', false)
                            })
                       }else{
                        setTimeout(() => {
                            commit('setloadings', false)
                        }, 3000);
                        
                    }



            }else{
                
                for(const data in state.dataAll){
                    if(format(new Date( state.dataAll[data].date), 'YYYY-MM-DD')>=date&&format(new Date( state.dataAll[data].date), 'YYYY-MM-DD')<=enddate){
                        const u = state.dataAll[data]
                        if(value=='All'){
                            u.dateFormatted = format(u.date, 'MMM DD, YYYY')
                            if (u.statusrow == 'sendcoin' ) {
                                if (u.type=='gem'){
                                    u.hashtags=[]
                                }
                                if(!givenMember[u.sender_email]){
                                    givenMember[u.sender_email]=[]
                                }
                                givenMember[u.sender_email].push(u)
            
                                if(!receivedMember[u.send_to_email]){
                                    receivedMember[u.send_to_email]=[]
                                }
                                
                                receivedMember[u.send_to_email].push(u)
                                if(u.core_value_ai){
                                    if(!u.hashtags){
                                        u.hashtags=[]
                                    }
                                    let count=0
                                    for(const i in u.core_value_ai){
                                        if(u.core_value_ai[i].rating>4){
                                            u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
                                            count++
                                        }else{
                                            if(u.hashtag_prev){
                                                u.hashtags[count]={name:u.hashtag_prev[count],rating:u.core_value_ai[i].rating}
                                            }else{
                                                u.hashtags[count]={name:'',rating:u.core_value_ai[i].rating}
                                            }
                                        }
                                        
                                    }
                                }
                                let emailKey=u.sender_email.replace(/\./g, '||')
                                if(alluser[emailKey]){
                                    if (! recognition[u.sender_email]) {
                                        recognition[u.sender_email] = {
                                            key:u.id,
                                            email: u.sender_email,
                                            profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                            firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                            lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                            shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                            teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                            team_id:alluser[emailKey].team,
                                            impactRating:alluser[emailKey].impact_rating,
                                            tag:u.hashtag,
                                            date:u.date,
                                            given: 0,
                                            received: 0,
                                            ratio: '',
                                            sortRatio:0
                                        }
                                    }
                                recognition[u.sender_email].given ++
            
                                }
                                emailKey=u.send_to_email.replace(/\./g, '||')
                                if(alluser[emailKey]){
                                    if (! recognition[u.send_to_email]) {
                                    const emailKey=u.send_to_email.replace(/\./g, '||')
                                    recognition[u.send_to_email] = {
                                        key:u.id,
                                        email: u.send_to_email,
                                        profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                        firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                        lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                        shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                        teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                        team_id:alluser[emailKey].team,
                                        impactRating:alluser[emailKey].impact_rating,
                                        tag:u.hashtag,
                                        date:u.date,
                                        given: 0,
                                        received: 0,
                                        ratio: '',
                                        sortRatio:0,
                                        order_Ratio:0,
                                        order_Received:0,
                                        order_Given:0
                                    }
                                    }
                                    recognition[u.send_to_email].received ++
                                }
                                if(u.core_value_ai){
                                    emailKey=u.sender_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        if(!alignment[u.sender_email]){
                                            alignment[u.sender_email]={
                                                email: u.sender_email,
                                                profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                                firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                                lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                                shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                                teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                                team_id:alluser[emailKey].team,
                                                impactRating:alluser[emailKey].impact_rating,
                                                tag:u.hashtag,
                                                effortGiven:0,
                                                totalGiven:0,
                                                effortReceived:0,
                                                totalReceived:0,
                                                alignmentGiven:0,
                                                alignmentReceived:0,
                                                alignmentRatio:0}
                                        }
                                        
        
                                    }
                                    emailKey=u.send_to_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        if(!alignment[u.send_to_email]){
                                            //const emailKey=u.send_to_email.replace(/\./g, '||')
                                            alignment[u.send_to_email]={
                                                email: u.send_to_email,
                                                profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                                firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                                lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                                shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                                teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                                effortGiven:0,totalGiven:0,effortReceived:0,totalReceived:0,
                                                team_id:alluser[emailKey].team,
                                                impactRating:alluser[emailKey].impact_rating,
                                                alignmentGiven:0,
                                                alignmentReceived:0,
                                                alignmentRatio:0,
                                                order_alignmentRatio:0,
                                                order_alignmentGiven:0,
                                                order_alignmentReceived:0}
                                        }
                                        
                                    }
                                    // for(const i in u.core_value_ai){
                                    //     if(u.core_value_ai[i].rating){
                                           
                                    //         emailKey=u.sender_email.replace(/\./g, '||')
                                    //         if(alluser[emailKey]){
                                    //             alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+parseFloat(u.core_value_ai[i].rating)
                                    //             alignment[u.sender_email].totalGiven++
                                    //         }
                                    //         emailKey=u.send_to_email.replace(/\./g, '||')
                                            
                                    //         if(alluser[emailKey]){
                                    //             alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+parseFloat(u.core_value_ai[i].rating)
                                    //             alignment[u.send_to_email].totalReceived++
                                    //         }
                                    //     }
                                     
                                    // }
                                    let rating = 0;
                                let _rating = 0;
                                if(u.statusrow == 'sendcoin'){
                                    for(const i in u.core_value_ai){
                                        if(u.core_value_ai[i].rating){
                                            if(value==u.hashtag[i]){
                                                emailKey=u.sender_email.replace(/\./g, '||')
                                                if(alluser[emailKey]){
                                                    if(_rating < parseFloat(u.core_value_ai[i].rating)){
                                                        _rating = parseFloat(u.core_value_ai[i].rating);
                                                    }
                                                    
                                                }
            
                                                emailKey=u.send_to_email.replace(/\./g, '||')
                                                
                                                if(alluser[emailKey]){
                                                    if(rating < parseFloat(u.core_value_ai[i].rating)){
                                                        rating = parseFloat(u.core_value_ai[i].rating);
                                                    }
                                                    
                                                }
                                            }
                                        }
                                     
                                    }
                                    emailKey=u.sender_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+_rating
                                        alignment[u.sender_email].totalGiven++
                                    }
                                    
                                    emailKey=u.send_to_email.replace(/\./g, '||')
                                    
                                    if(alluser[emailKey]){
                          
                                    alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+rating
                                    alignment[u.send_to_email].totalReceived++
                                    }
                                }
                                    
                                }
                            }
                        }else{
                            const findHashtag=_.find(u.hashtag, function(o) { return o == value});
                            let status_hashtag=false
                             if(findHashtag){
                                u.dateFormatted = format(u.date, 'MMM DD, YYYY')
                                if(u.core_value_ai){
                                    for(const i in u.core_value_ai){
                                        if(u.core_value_ai[i].rating){
                                            if(value==u.hashtag[i]){
                                                status_hashtag=true
                                            }

                                        }
                                    }
                                }



                            if ((u.statusrow == 'sendcoin' )&&status_hashtag) {
                                if (u.type=='gem'){
                                    u.hashtags=[]
                                }
                                if(!givenMember[u.sender_email]){
                                    givenMember[u.sender_email]=[]
                                }
                                givenMember[u.sender_email].push(u)
                                if(!receivedMember[u.send_to_email]){
                                    receivedMember[u.send_to_email]=[]
                                }
                                
                                receivedMember[u.send_to_email].push(u)
                                if(u.core_value_ai){
                                    if(!u.hashtags){
                                        u.hashtags=[]
                                    }
                                    let count=0
                                    for(const i in u.core_value_ai){
                                        
                                        if(u.core_value_ai[i].rating>4){
                                            u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
                                            count++
                                        }else{
                                            if(u.hashtag_prev){
                                                u.hashtags[count]={name:u.hashtag_prev[count],rating:u.core_value_ai[i].rating}
                                            }else{
                                                u.hashtags[count]={name:'',rating:u.core_value_ai[i].rating}
                                            }
                                        }
                                        
                                    }
                                }
                                let emailKey=u.sender_email.replace(/\./g, '||')
                                if(alluser[emailKey]){
                                    if (! recognition[u.sender_email]) {
                                        recognition[u.sender_email] = {
                                            key:u.id,
                                            email: u.sender_email,
                                            profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                            firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                            lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                            shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                            teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                            team_id:alluser[emailKey].team,
                                            impactRating:alluser[emailKey].impact_rating,
                                            tag:u.hashtag,
                                            date:u.date,
                                            given: 0,
                                            received: 0,
                                            ratio: '',
                                            sortRatio:0
                                        }
                                    }
                                recognition[u.sender_email].given ++
            
                                }
                                emailKey=u.send_to_email.replace(/\./g, '||')
                                if(alluser[emailKey]){
                                    if (! recognition[u.send_to_email]) {
                                    const emailKey=u.send_to_email.replace(/\./g, '||')
                                    recognition[u.send_to_email] = {
                                        key:u.id,
                                        email: u.send_to_email,
                                        profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                        firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                        lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                        shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                        teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                        team_id:alluser[emailKey].team,
                                        impactRating:alluser[emailKey].impact_rating,
                                        tag:u.hashtag,
                                        date:u.date,
                                        given: 0,
                                        received: 0,
                                        ratio: '',
                                        sortRatio:0,
                                        order_Ratio:0,
                                        order_Received:0,
                                        order_Given:0
                                    }
                                    }
                                    recognition[u.send_to_email].received ++
                                }
                                if(u.core_value_ai){
                                    emailKey=u.sender_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        if(!alignment[u.sender_email]){
                                            alignment[u.sender_email]={
                                                email: u.sender_email,
                                                profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                                firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                                lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                                shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                                teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                                team_id:alluser[emailKey].team,
                                                impactRating:alluser[emailKey].impact_rating,
                                                tag:u.hashtag,
                                                effortGiven:0,
                                                totalGiven:0,
                                                effortReceived:0,
                                                totalReceived:0,
                                                alignmentGiven:0,
                                                alignmentReceived:0,
                                                alignmentRatio:0}
                                        }
                                        
        
                                    }
                                    emailKey=u.send_to_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        if(!alignment[u.send_to_email]){
                                            //const emailKey=u.send_to_email.replace(/\./g, '||')
                                            alignment[u.send_to_email]={
                                                email: u.send_to_email,
                                                profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                                firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                                lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                                shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                                teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                                team_id:alluser[emailKey].team,
                                                effortGiven:0,
                                                totalGiven:0,
                                                effortReceived:0,
                                                totalReceived:0,
                                                impactRating:alluser[emailKey].impact_rating,
                                                alignmentGiven:0,
                                                alignmentReceived:0,
                                                alignmentRatio:0,
                                                order_alignmentRatio:0,
                                                order_alignmentGiven:0,
                                                order_alignmentReceived:0}
                                        }
                                        
                                    }
                               
                                    let rating = 0;
                                let _rating = 0;
                                if(u.statusrow == 'sendcoin'){
                                    for(const i in u.core_value_ai){
                                        
                                        if(u.core_value_ai[i].rating){
                                            if(value==u.hashtag[i]){
                                                emailKey=u.sender_email.replace(/\./g, '||')
                                                if(alluser[emailKey]){
                                                    if(_rating < parseFloat(u.core_value_ai[i].rating)){
                                                        _rating = parseFloat(u.core_value_ai[i].rating);
                                                    }
                                                    
                                                }
            
                                                emailKey=u.send_to_email.replace(/\./g, '||')
                                                
                                                if(alluser[emailKey]){
                                                    if(rating < parseFloat(u.core_value_ai[i].rating)){
                                                        rating = parseFloat(u.core_value_ai[i].rating);
                                                    }
                                                    
                                                }
                                        }
                                    }
                                     
                                    }
                                    emailKey=u.sender_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                       
                                        alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+_rating
                                        alignment[u.sender_email].totalGiven++
                                    }
                                    
                                    emailKey=u.send_to_email.replace(/\./g, '||')
                                    
                                    if(alluser[emailKey]){
                          
                                    alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+rating
                                    alignment[u.send_to_email].totalReceived++
                                    }
                                }
                                    
                                }
                            }
            
                            }
        
                        }
                     }   
                    }
        
                    for (const i in recognition) {
                        if (recognition[i].received > 0) {
                            recognition[i].sortRatio=(recognition[i].given / recognition[i].received)
                            recognition[i].ratio = (recognition[i].given / recognition[i].received).toFixed(1)
                        } else {
                            recognition[i].sortRatio=recognition[i].given
                            recognition[i].ratio = recognition[i].given.toFixed() + '*'
                        }
                        
                    }
                    for(const i in alignment){
                        if(alignment[i].totalGiven>0){
                            alignment[i].alignmentGiven=isNaN(alignment[i].effortGiven/alignment[i].totalGiven)?0: (alignment[i].effortGiven/alignment[i].totalGiven).toFixed(1)
                        }
                        if(alignment[i].totalReceived>0){
                            alignment[i].alignmentReceived= isNaN(alignment[i].effortReceived/alignment[i].totalReceived)?0:(alignment[i].effortReceived/alignment[i].totalReceived).toFixed(1)
                        }
                        alignment[i].alignmentRatio= isNaN((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived))?0:((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived)).toFixed(1)
                    }
        
        
                    const given = _.orderBy(recognition, ['given'], ['desc'])
                    const received = _.orderBy(recognition, ['received'], ['desc'])
                    const sortRatio = _.orderBy(recognition, ['sortRatio'], ['desc'])
                    let count=0
                    let given_order=0
                    for(const i in given){
                      if(given_order!=recognition[given[i].email].given){
                        given_order=recognition[given[i].email].given
                        count++
                        state.last_rank_given=count
                      }
                        recognition[given[i].email].order_Given=count
                     
                    }
                    let count_received=0
                    let received_order=0
                    for(const i in received){
                      if(received_order!=recognition[received[i].email].received){
                        received_order=recognition[received[i].email].received
                        count_received++
                        state.last_rank_received=count_received
                      }
                      recognition[received[i].email].order_Received=count_received
                      
        
                      
                    }
                    let count_ratio=0
                    let ratio_order=0
                    for(const i in sortRatio){
                      if(ratio_order!=recognition[sortRatio[i].email].sortRatio){
                        ratio_order=recognition[sortRatio[i].email].sortRatio
                        count_ratio++
                        state.last_rank_ratio=count_ratio
                      }
                      
                      recognition[sortRatio[i].email].order_Ratio=count_ratio
                      
                    }
                    const alignmentGiven = _.orderBy(alignment, ['alignmentGiven'], ['desc'])
                    const alignmentReceived = _.orderBy(alignment, ['alignmentReceived'], ['desc'])
                    const alignmentRatio = _.orderBy(alignment, ['alignmentRatio'], ['desc'])
                    let count_alignmentGiven=0
                    let alignmentGiven_order=0
                    for(const i in alignmentGiven){
                        if(alignmentGiven_order!=alignment[alignmentGiven[i].email].alignmentGiven){
                          alignmentGiven_order=alignment[alignmentGiven[i].email].alignmentGiven
                          count_alignmentGiven++
                        }
                        
                            alignment[alignmentGiven[i].email].order_alignmentGiven=count_alignmentGiven
                    }
        
                    let count_alignmentReceived=0
                    let alignmentReceived_order=0
                    for(const i in alignmentReceived){
                        if(alignmentReceived_order!=alignment[alignmentReceived[i].email].alignmentReceived){
                            alignmentReceived_order=alignment[alignmentReceived[i].email].alignmentReceived
                          count_alignmentReceived++
                        }
                            alignment[alignmentReceived[i].email].order_alignmentReceived=count_alignmentReceived
                    }
                    let count_alignmentRatio=0
                    let alignmentRatio_order=0
                    for(const i in alignmentRatio){
                        if(alignmentRatio_order!=alignment[alignmentRatio[i].email].alignmentRatio){
                            alignmentRatio_order=alignment[alignmentRatio[i].email].alignmentRatio
                            count_alignmentRatio++
                        }
                            alignment[alignmentRatio[i].email].order_alignmentRatio=count_alignmentRatio
                    }
                    //console.log('givenMember',givenMember)
                    
                    commit('setGivenMember', givenMember)
                    commit('setReceivedMember', receivedMember)
                    await commit('setRecognition', recognition)
                    await commit('setAlignment', alignment)
                    await commit('setRecognitionAll', recognition)
                    await commit('setAlignmentAll', alignment)
                    if(state.statusTeam){
                            dispatch('changeTeam',state.statusTeam).then(()=>{
                                commit('setloadings', false)
                            })
                       }else{
                        setTimeout(() => {
                            commit('setloadings', false)
                        }, 3000);
                        
                    }
            }
            

        },
        async changeTimeData({commit, dispatch, state,rootState} : any,value : any){
            let startdate = format(new Date(value[0]), 'YYYY-MM-DD')
            let enddate = format(new Date(value[1]), 'YYYY-MM-DD')
            let recognition = {}
            let alignment={}
            let givenMember={}
            let receivedMember={}
            const alluser=rootState.main.allUser
            const team=rootState.main.allTeam
            console.log('getHerepoint')
            await firebase.firestore().collection('here_point').where('company', '==', rootState.authen.user.company).where('statusrow','in',['sendcoin']).where('date', '>=', startdate).where('date', '<=', enddate).get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    const u = doc.data()
                    u.id = doc.id
                    u.dateFormatted = format(u.date, 'MMM DD, YYYY')
                    state.dataAllnotpast6month.push(u)
                    if (u.statusrow == 'sendcoin') {
                        if(!givenMember[u.sender_email]){
                            givenMember[u.sender_email]=[]
                        }
                        if (u.type=='gem'){
                            u.hashtags=[]
                        }
                        if(u.core_value_ai){
                            if(!u.hashtags){
                                u.hashtags=[]
                            }
                            let count=0
                            for(const i in u.core_value_ai){
                                if(u.core_value_ai[i].rating>4){
                                    u.hashtags[count]={name:u.hashtag[count],rating:u.core_value_ai[i].rating}
                                    count++
                                }else{
                                    if(u.hashtag_prev){
                                        u.hashtags[count]={name:u.hashtag_prev[count],rating:u.core_value_ai[i].rating}
                                    }else{
                                        u.hashtags[count]={name:'',rating:u.core_value_ai[i].rating}
                                    }
                                }   
                            }
                        }
                        const _emailKey=u.send_to_email.replace(/\./g, '||')
                        u.profilepic=alluser[_emailKey]&&alluser[_emailKey].profilepic?alluser[_emailKey].profilepic:'',
                        u.shortname=alluser[_emailKey]?alluser[_emailKey].firstname.charAt(0) + alluser[_emailKey].lastname.charAt(0):'',
                        givenMember[u.sender_email].push(u)

                        if(!receivedMember[u.send_to_email]){
                            receivedMember[u.send_to_email]=[]
                        }
                        receivedMember[u.send_to_email].push(u)
                        let emailKey=u.sender_email.replace(/\./g, '||')
                        
                        if(alluser[emailKey]){
                            if (! recognition[u.sender_email]) {
                                recognition[u.sender_email] = {
                                    key:u.id,
                                    email: u.sender_email,
                                    // email_to:u.send_to_email,
                                    profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                    firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                    lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                    shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                    teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                    team_id:alluser[emailKey].team,
                                    impactRating:alluser[emailKey].impact_rating,
                                    tag:u.hashtag,
                                    date:u.date,
                                    given: 0,
                                    received: 0,
                                    ratio: '',
                                }
                            }
                        recognition[u.sender_email].given ++

                        }
                        emailKey=u.send_to_email.replace(/\./g, '||')
                        
                        if(alluser[emailKey]){
                            if (! recognition[u.send_to_email]) {
                            const emailKey=u.send_to_email.replace(/\./g, '||')
                            recognition[u.send_to_email] = {
                                key:u.id,
                                email: u.send_to_email,
                                // email_to:u.send_to_email,
                                profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                team_id:alluser[emailKey].team,
                                impactRating:alluser[emailKey].impact_rating,
                                tag:u.hashtag,
                                date:u.date,
                                given: 0,
                                received: 0,
                                ratio: '',
                                sortRatio:0,
                                order_Ratio:0,
                                order_Received:0,
                                order_Given:0
                            }
                            }
                            recognition[u.send_to_email].received ++
                        }
                        if(u.core_value_ai){
                            emailKey=u.sender_email.replace(/\./g, '||')
                            if(alluser[emailKey]){
                                if(!alignment[u.sender_email]){
                                    alignment[u.sender_email]={
                                        email: u.sender_email,
                                        profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                        firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                        lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                        shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                        teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                        team_id:alluser[emailKey].team,
                                        impactRating:alluser[emailKey].impact_rating,
                                        tag:u.hashtag,
                                        effortGiven:0,
                                        totalGiven:0,
                                        effortReceived:0,
                                        totalReceived:0,
                                        alignmentGiven:0,
                                        alignmentReceived:0,
                                        alignmentRatio:0}
                                }
                                

                            }
                            emailKey=u.send_to_email.replace(/\./g, '||')
                            if(alluser[emailKey]){
                                if(!alignment[u.send_to_email]){
                                    //const emailKey=u.send_to_email.replace(/\./g, '||')
                                    alignment[u.send_to_email]={
                                        email: u.send_to_email,
                                        profilepic: alluser[emailKey]&&alluser[emailKey].profilepic?alluser[emailKey].profilepic:'',
                                        firstname: alluser[emailKey]&&alluser[emailKey].firstname?alluser[emailKey].firstname:'',
                                        lastname: alluser[emailKey]&&alluser[emailKey].lastname?alluser[emailKey].lastname:'',
                                        shortname:alluser[emailKey]?alluser[emailKey].firstname.charAt(0) + alluser[emailKey].lastname.charAt(0):'',
                                        teamname:alluser[emailKey]&&alluser[emailKey].team?team[alluser[emailKey].team]?team[alluser[emailKey].team].name:'':'',
                                        team_id:alluser[emailKey].team,
                                        effortGiven:0,totalGiven:0,effortReceived:0,totalReceived:0,
                                        impactRating:alluser[emailKey].impact_rating,
                                        alignmentGiven:0,
                                        alignmentReceived:0,
                                        alignmentRatio:0,
                                        order_alignmentRatio:0,
                                        order_alignmentGiven:0,
                                        order_alignmentReceived:0}
                                }
                                
                            }
                            // for(const i in u.core_value_ai){
                            //     if(u.core_value_ai[i].rating){
                                   
                            //         emailKey=u.sender_email.replace(/\./g, '||')
                            //         if(alluser[emailKey]){
                            //             alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+parseFloat(u.core_value_ai[i].rating)
                            //             alignment[u.sender_email].totalGiven++
                            //         }
                            //         emailKey=u.send_to_email.replace(/\./g, '||')
                                    
                            //         if(alluser[emailKey]){
                            //             alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+parseFloat(u.core_value_ai[i].rating)
                            //             alignment[u.send_to_email].totalReceived++
                            //         }
                            //     }
                             
                            // }
                            let rating = 0;
                                let _rating = 0;
                                if(u.statusrow == 'sendcoin'){
                                    for(const i in u.core_value_ai){
                                        if(u.core_value_ai[i].rating){
                                           
                                            emailKey=u.sender_email.replace(/\./g, '||')
                                            if(alluser[emailKey]){
                                                if(_rating < parseFloat(u.core_value_ai[i].rating)){
                                                    _rating = parseFloat(u.core_value_ai[i].rating);
                                                }
                                                
                                            }
        
                                            emailKey=u.send_to_email.replace(/\./g, '||')
                                            
                                            if(alluser[emailKey]){
                                                if(rating < parseFloat(u.core_value_ai[i].rating)){
                                                    rating = parseFloat(u.core_value_ai[i].rating);
                                                }
                                                
                                            }
                                        }
                                     
                                    }
                                    emailKey=u.sender_email.replace(/\./g, '||')
                                    if(alluser[emailKey]){
                                        alignment[u.sender_email].effortGiven=alignment[u.sender_email].effortGiven+_rating
                                        alignment[u.sender_email].totalGiven++
                                    }
                                    
                                    emailKey=u.send_to_email.replace(/\./g, '||')
                                    
                                    if(alluser[emailKey]){
                          
                                    alignment[u.send_to_email].effortReceived=alignment[u.send_to_email].effortReceived+rating
                                    alignment[u.send_to_email].totalReceived++
                                    }
                                }
                            
                        }
                    }
                });
                for (const i in recognition) {
                    
                    if (recognition[i].received > 0) {
                        recognition[i].sortRatio=(recognition[i].given / recognition[i].received)
                        recognition[i].ratio = (recognition[i].given / recognition[i].received).toFixed(1)
                    } else {
                        recognition[i].sortRatio=recognition[i].given
                        recognition[i].ratio = recognition[i].given.toFixed() + '*'
                    }
                    
                }
                for(const i in alignment){
                    if(alignment[i].totalGiven>0){
                        alignment[i].alignmentGiven=isNaN(alignment[i].effortGiven/alignment[i].totalGiven)?0: (alignment[i].effortGiven/alignment[i].totalGiven).toFixed(1)
                    }
                    if(alignment[i].totalReceived>0){
                        alignment[i].alignmentReceived= isNaN(alignment[i].effortReceived/alignment[i].totalReceived)?0:(alignment[i].effortReceived/alignment[i].totalReceived).toFixed(1)
                    }
                    alignment[i].alignmentRatio= isNaN((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived))?0:((alignment[i].effortGiven+alignment[i].effortReceived)/(alignment[i].totalGiven+alignment[i].totalReceived)).toFixed(1)
                }

            const given = _.orderBy(recognition, ['given'], ['desc'])
            const received = _.orderBy(recognition, ['received'], ['desc'])
            const sortRatio = _.orderBy(recognition, ['sortRatio'], ['desc'])
            let count=0
            let given_order=0
            for(const i in given){
              if(given_order!=recognition[given[i].email].given){
                given_order=recognition[given[i].email].given
                count++
                state.last_rank_given=count
              }
                recognition[given[i].email].order_Given=count
              if(count%10==1){
                recognition[given[i].email].orderGiven=count+'st'
              }else if(count%10==2){
                recognition[given[i].email].orderGiven=count+'nd'
              }else if(count%10==3){
                recognition[given[i].email].orderGiven=count+'rd'
              }else{
                recognition[given[i].email].orderGiven=count+'th'
              }
            }
            let count_received=0
            let received_order=0
            for(const i in received){
              if(received_order!=recognition[received[i].email].received){
                received_order=recognition[received[i].email].received
                count_received++
                state.last_rank_received=count_received
              }
              recognition[received[i].email].order_Received=count_received
              if(count_received%10==1){
                recognition[received[i].email].orderReceived=count_received+'st'
              }else if(count_received%10==2){
                recognition[received[i].email].orderReceived=count_received+'nd'
              }else if(count_received%10==3){
                recognition[ received[i].email].orderReceived=count_received+'rd'
              }else{
                recognition[ received[i].email].orderReceived=count_received+'th'
              }

              
            }
            let count_ratio=0
            let ratio_order=0
            for(const i in sortRatio){
              if(ratio_order!=recognition[sortRatio[i].email].sortRatio){
                ratio_order=recognition[sortRatio[i].email].sortRatio
                count_ratio++
                state.last_rank_ratio=count_ratio
              }
              
              recognition[sortRatio[i].email].order_Ratio=count_ratio
              if(count_ratio%10==1){
                recognition[sortRatio[i].email].orderRatio=count_ratio+'st'
              }else if(count_ratio%10==2){
                recognition[sortRatio[i].email].orderRatio=count_ratio+'nd'
              }else if(count_ratio%10==3){
                recognition[sortRatio[i].email].orderRatio=count_ratio+'rd'
              }else{
                recognition[sortRatio[i].email].orderRatio=count_ratio+'th'
              }
            }
            const alignmentGiven = _.orderBy(alignment, ['alignmentGiven'], ['desc'])
            const alignmentReceived = _.orderBy(alignment, ['alignmentReceived'], ['desc'])
            const alignmentRatio = _.orderBy(alignment, ['alignmentRatio'], ['desc'])
            let count_alignmentGiven=0
            let alignmentGiven_order=0
            for(const i in alignmentGiven){
                if(alignmentGiven_order!=alignment[alignmentGiven[i].email].alignmentGiven){
                  alignmentGiven_order=alignment[alignmentGiven[i].email].alignmentGiven
                  count_alignmentGiven++
                }
                    alignment[alignmentGiven[i].email].order_alignmentGiven=count_alignmentGiven
            }

            let count_alignmentReceived=0
            let alignmentReceived_order=0
            for(const i in alignmentReceived){
                if(alignmentReceived_order!=alignment[alignmentReceived[i].email].alignmentReceived){
                    alignmentReceived_order=alignment[alignmentReceived[i].email].alignmentReceived
                  count_alignmentReceived++
                }
                    alignment[alignmentReceived[i].email].order_alignmentReceived=count_alignmentReceived
            }
            let count_alignmentRatio=0
            let alignmentRatio_order=0
            for(const i in alignmentRatio){
                if(alignmentRatio_order!=alignment[alignmentRatio[i].email].alignmentRatio){
                    alignmentRatio_order=alignment[alignmentRatio[i].email].alignmentRatio
                    count_alignmentRatio++
                }
                    alignment[alignmentRatio[i].email].order_alignmentRatio=count_alignmentRatio
            }

                commit('setRecognition', recognition)
                commit('setAlignment', alignment)
                commit('setGivenMember', givenMember)
                commit('setReceivedMember', receivedMember)
                commit('setRecognitionAll', recognition)
                commit('setAlignmentAll', alignment)

                if(state.statusTeam){
                    dispatch('changeTeam',state.statusTeam).then(()=>{
                        commit('setloadings', false)
                    })
               }else{
                commit('setloadings', false)
               }
            });
        }
    },
    getters: {
        list_month: (state : any) => {
            return state.list_month
        },
        teamAndcohort: (state : any) => {
            return state.teamAndcohort
        },
        recognitionValue: (state : any) => {
            return state.recognitionValue
        },
        recognitionGiven: (state : any) => {
            const recognition = _.orderBy(state.recognition, ['order_Given'], ['asc'])
            return recognition
        },
        recognitionReceived: (state : any) => {
          const recognition = _.orderBy(state.recognition, ['order_Received'], ['asc'])

          return recognition
      },
        recognitionRatio: (state : any) => {
            const recognition = _.orderBy(state.recognition, ['order_Ratio'], ['asc'])
            return recognition
        },
        alignmentGiven: (state : any) => {
            const alignment = _.orderBy(state.alignment, ['order_alignmentGiven'], ['asc'])
            return alignment
        },
        alignmentReceived: (state : any) => {
            const alignment = _.orderBy(state.alignment, ['order_alignmentReceived'], ['asc'])
            return alignment
        },
        alignmentRatio: (state : any) => {
            const alignment = _.orderBy(state.alignment, ['order_alignmentRatio'], ['asc'])
            return alignment
        },
        givenMember: (state : any) => {
            return state.givenMember
        },
        receivedMember: (state : any) => {
            return state.receivedMember
        },
        impactRating: (state : any) => {

            return state.impact_rating
        },
        loadingsImpactRating: (state : any) => {

            return state.loadingsImpactRating
        },
        loadings: (state : any) => {

            return state.loadings
        },
        pickerOptions: (state : any) => {
            return state.pickerOptions
        },
    }
}
